export const translations = {
  en: {
    // Nav
    'nav.home': 'Home',
    'nav.search': 'Search Promotions',
    'nav.search_products': 'Search Products', // New
    'nav.add': 'Add Promotion',
    'nav.scan': 'Scan Promotion',
    'nav.scan_product': 'Scan Product', // New
    'nav.contact': 'Contact Us', // New
    'nav.my_space': 'My Space', // New
    'nav.my_dashboard': 'My Dashboard', // New
    'nav.my_promotions': 'My Promotions',
    'nav.my_inbox': 'My Inbox',
    'nav.my_favourites': 'My Favourites',
    'nav.my_achievements': 'My Achievements',
    'nav.memberships': 'Memberships',
    'nav.business_plans': 'Business Plans',
    'nav.admin': 'Admin',
    'nav.business_tools': 'Business Tools',
    'nav.business_profile': 'Business Profile', // New
    'nav.premise_mgmt': 'Premise Management', // New
    'nav.claim_premise': 'Claim Premise', // New
    'nav.add_simple_promo': 'Add Simple Promotion', // New
    'nav.target_audience': 'Target Audience', // New
    'nav.total_saved': 'Total Saved Site-wide', // New
    'nav.welcome': 'Welcome',
    'nav.logout': 'Logout',
    'nav.login': 'Register / Login',
    'nav.market': 'Marketplace', // New
    'nav.donate': 'Donate',
    'nav.bill_analyzer': 'Bill Analyzer',
    'nav.tax_calculator': 'Tax Rebate',
    'nav.handy_tools': 'Handy Tools',
    'nav.open_account_calculator': 'Open Account',
    'nav.it': 'i.t',
    'nav.card_holders': 'Card Holders',
    'nav.today_special': "Today's Special",
    'nav.dev_portal': 'Developer Portal',
    'nav.erd': 'ERD',
    'erd.title': 'Developer ERD Visualizer',
    'erd.subtitle': 'Dynamically generated from backend database structs in handlers.go',
    'erd.btn_test_render': '🧪 Test Render Simple',
    'erd.btn_refresh': '🔄 Refresh',
    'erd.btn_view_code': '💻 View Code',
    'erd.btn_view_diagram': '👁️ View Diagram',
    'erd.btn_copy_code': '📋 Copy Code',
    'erd.filter_entities': 'Filter Entities',
    'erd.select_all': 'Select All',
    'erd.clear_all': 'Clear All',
    'erd.loading': 'Parsing handlers.go structs and building ERD diagram...',
    'erd.copied_msg': 'Mermaid syntax copied to clipboard!',

    // Consent
    'nav.consent_pre': 'By continuing, you agree to our',
    'nav.terms': 'Terms of Service',
    'nav.consent_mid': 'and acknowledge our',
    'nav.privacy': 'Privacy Policy',
    'nav.consent_post': '.',

    // Admin Receipt Verification
    'admin.receipts.title': 'Receipt Verification',
    'admin.receipts.promotion': 'Promotion',
    'admin.receipts.date': 'Date',
    'admin.receipts.amount': 'Amount',
    'admin.receipts.user': 'User',
    'admin.receipts.status_verified': 'Verified',
    'admin.receipts.status_rejected': 'Rejected',
    'admin.receipts.status_na': 'N/A',
    'admin.receipts.status_pending': 'Pending',
    'admin.receipts.btn_verify': 'Verify',
    'admin.receipts.btn_reject': 'Reject',
    'admin.receipts.btn_na': 'N/A',
    'admin.receipts.no_data': 'No pending receipts.',

    // Admin
    'admin.subscriptions': 'All Subscriptions',
    'admin.users': 'Users',
    'admin.messages': 'Customer Messages',
    'admin.messages.review_title': 'Review Message',
    'admin.messages.from': 'From',
    'admin.messages.user_profile': 'User Profile',
    'admin.messages.member': 'Member',
    'admin.messages.phone': 'Phone',
    'admin.messages.date': 'Date',
    'admin.messages.message_label': 'Message',
    'admin.messages.admin_remarks': 'Admin Remarks',
    'admin.messages.internal_notes_placeholder': 'Internal notes...',
    'admin.messages.cancel': 'Cancel',
    'admin.messages.close_ticket': 'Close Ticket',
    'admin.messages.reopen_ticket': 'Reopen Ticket',
    'admin.messages.title': 'Customer Messages',
    'admin.messages.open': 'Open',
    'admin.messages.closed': 'Closed',
    'admin.messages.loading': 'Loading...',
    'admin.messages.no_open_messages': 'No open messages found.',
    'admin.messages.no_closed_messages': 'No closed messages found.',
    'admin.messages.update_failed': 'Update failed',
    'admin.reports': 'Reported Issues',
    'admin.logs.title': 'API System Logs',
    'admin.logs.subtitle': 'Troubleshoot backend processes like Bill Uploads.',
    'admin.logs.loading': 'Loading logs...',
    'admin.logs.no_data': 'No logs found.',
    'admin.logs.time': 'Time',
    'admin.logs.endpoint': 'Endpoint',
    'admin.logs.status': 'Status',
    'admin.logs.ip_address': 'IP Address',
    'admin.logs.user_id': 'User ID',
    'admin.logs.message': 'Message',
    'admin.logs.action': 'Action',
    'admin.logs.details': 'Details',
    'admin.logs.prev': 'Prev',
    'admin.logs.next': 'Next',
    'admin.logs.page_of': 'Page {page} of {totalPages}',
    'admin.logs.details_title': 'Log Details',
    'admin.logs.status_label': 'Status:',
    'admin.logs.time_label': 'Time:',
    'admin.logs.endpoint_label': 'Endpoint:',
    'admin.logs.ip_label': 'IP:',
    'admin.logs.user_id_label': 'User ID:',
    'admin.logs.message_label': 'Message:',
    'admin.logs.payload_label': 'Payload / Raw Response:',
    'admin.logs.no_payload': 'No payload recorded.',
    'admin.logs.filters.title': 'Filters',
    'admin.logs.filters.start_date': 'Start Date & Time',
    'admin.logs.filters.end_date': 'End Date & Time',
    'admin.logs.filters.endpoint': 'Endpoint URL',
    'admin.logs.filters.status': 'Status Code',
    'admin.logs.filters.ip': 'IP Address',
    'admin.logs.filters.user_id': 'User ID',
    'admin.logs.filters.ai_version': 'AI Model Version',
    'admin.logs.filters.btn_filter': 'Apply Filters',
    'admin.logs.filters.btn_clear': 'Clear Filters',
    'admin.banks': 'Banks',
    'admin.banks.title': 'Bank Master List',
    'admin.banks.add_bank': 'Add Bank',
    'admin.banks.edit_bank': 'Edit Bank',
    'admin.banks.add_new_bank': 'Add New Bank',
    'admin.banks.bank_name_en': 'Canonical Name (English)',
    'admin.banks.bank_name_zh': 'Traditional Chinese (繁體中文)',
    'admin.banks.bank_name_ja': 'Japanese (日本語)',
    'admin.banks.bank_key': 'Identifier Key',
    'admin.banks.country': 'Country Code',
    'admin.banks.save_changes': 'Save Changes',
    'admin.banks.cancel': 'Cancel',
    'admin.banks.bulk_upload': 'Bulk Upload',
    'admin.banks.bulk_upload_hint': 'CSV: name,country,nameZh,nameJa,key',
    'admin.banks.upload_csv': 'Upload CSV',
    'admin.banks.uploading': 'Uploading...',
    'admin.banks.existing_banks': 'Existing Banks ({count})',
    'admin.banks.delete_confirm': 'Delete this bank?',
    'admin.banks.save_success': 'Bank added successfully.',
    'admin.banks.update_success': 'Bank updated successfully.',
    'admin.banks.delete_success': 'Bank deleted successfully.',
    'admin.banks.upload_success': 'Bulk upload successful! {count} added.',
    'admin.banks.no_banks': 'No banks found.',
    'admin.banks.loading': 'Loading...',
    'admin.banks.actions': 'Actions',
    'admin.banks.edit': 'Edit',
    'admin.banks.delete': 'Delete',
    'admin.credit_cards': 'Credit Cards',
    'admin.credit_cards.title': 'Credit Card Master List',
    'admin.credit_cards.short_tag': 'Short Tag',
    'admin.credit_cards.aliases': 'Aliases (comma-separated)',
    'admin.credit_cards.aliases_label': 'Aliases',
    'admin.credit_cards.bank_name': 'Bank Name',
    'admin.credit_cards.card_name': 'Card Name',
    'admin.credit_cards.issuer': 'Issuer',
    'admin.credit_cards.country': 'Country',
    'admin.credit_cards.active': 'Active',
    'admin.credit_cards.actions': 'Actions',
    'admin.credit_cards.add_card': 'Add Card',
    'admin.credit_cards.option_ai': 'Option 1: Import from Website (AI)',
    'admin.credit_cards.option_csv': 'Option 2: Bulk CSV Upload',
    'admin.credit_cards.option_manual': 'Option 3: Manual Entry',
    'admin.credit_cards.url_placeholder': 'Paste bank credit card page URL here...',
    'admin.credit_cards.extract_btn': 'Extract Cards',
    'admin.credit_cards.extracting_btn': 'Scanning...',
    'admin.credit_cards.upload_csv_btn': 'Upload CSV',
    'admin.credit_cards.save_success': 'Card added successfully.',
    'admin.credit_cards.update_success': 'Card updated successfully.',
    'admin.credit_cards.delete_confirm': 'Delete this card?',
    'admin.credit_cards.staging_title': 'Review & Save ({count})',
    'admin.credit_cards.no_records_upload': 'No valid records to upload',
    'admin.credit_cards.all_cards': 'All Credit Cards',
    'admin.credit_cards.loading': 'Loading list...',
    'admin.payment_methods': 'Payment Methods',
    'admin.stores': 'Stores',
    'admin.places': 'Place Maintenance',
    'admin.questions': 'Questions',
    'admin.categories': 'Categories',
    'admin.category_name_en': 'Canonical Name (English)',
    'admin.category_name_zh': 'Traditional Chinese (繁體中文)',
    'admin.category_name_ja': 'Japanese (日本語)',
    'admin.category_key': 'Identifier Key',
    'admin.category_normalize_btn': 'Split & Normalize Categories',
    'admin.category_normalize_confirm': 'This will automatically split any combined English/Chinese category names into dedicated fields and normalize existing promotions. Continue?',
    'admin.category_normalized_success': 'Categories and promotions successfully normalized!',
    'admin.invite': 'Create Invitation',
    'admin.web_scraper': "Web Scraper",
    'admin.missing_formulas': 'Missing Formulas',
    'admin.broadcast_message': 'Broadcast Message',
    'admin.receipt_verification': 'Receipt Verification',
    'admin.api_logs': 'System API Logs',
    'admin.recommendation_logs': 'Recommendation Logs',
    'admin.search_logs': 'Search Logs',
    'admin.banners': 'Banners',
    'admin.campaign': 'Campaign Manager',
    'admin.rewards': 'Redeemable Items',
    'admin.ai_models': 'AI Models Management',
    'admin.ai_models.title': 'AI Model Management',
    'admin.ai_models.discover_btn': 'Discover Gemini Models',
    'admin.ai_models.discover_deepseek_btn': 'Discover DeepSeek Models',
    'admin.ai_models.discovering': 'Discovering...',
    'admin.ai_models.discovering_deepseek': 'Discovering DeepSeek...',
    'admin.ai_models.models_title': 'Available AI Models',
    'admin.ai_models.failed_title': 'Recent Failed Models',
    'admin.ai_models.table_name': 'Model ID / Name',
    'admin.ai_models.table_provider': 'Provider',
    'admin.ai_models.table_display': 'Display Name',
    'admin.ai_models.table_status': 'Status',
    'admin.ai_models.table_actions': 'Actions',
    'admin.ai_models.table_failed_at': 'Failed At',
    'admin.ai_models.table_reason': 'Failure Reason',
    'admin.ai_models.table_priority': 'Priority',
    'admin.ai_models.status_enabled': 'Enabled',
    'admin.ai_models.status_disabled': 'Disabled',
    'admin.ai_models.btn_enable': 'Enable',
    'admin.ai_models.btn_disable': 'Disable',
    'admin.ai_models.btn_clear_fail': 'Clear Failure',
    'admin.ai_models.no_failed_models': 'No failed models tracked.',
    'admin.ai_models.no_models': 'No models found. Run discovery.',
    'rewards.out_of_stock': 'Out of Stock',

    'ai.title': 'AI Smart Recommendation',
    'ai.desc': 'Tell us how much you plan to spend, and our AI will calculate which of your cards gives you the maximum reward right now.',
    'ai.categories': 'Categories',
    'ai.select_categories': 'Select Categories',
    'ai.target_spending': 'Target Spending ($) *',
    'ai.using_cards': 'Using Cards:',
    'ai.using_payment_methods': 'Using Payment Methods:',
    'ai.none_found': 'None found. Add in Profile.',
    'ai.thinking': 'Thinking...',
    'ai.get_recommendation': 'Get Recommendation',
    'ai.top_pick': 'Top Pick:',
    'ai.estimated_reward': 'Estimated Reward:',
    'ai.no_suitable': 'No suitable promotion found for this spending scenario.',
    'ai.more': 'more',
    'ai.store_name': 'Store Name',
    'ai.store_placeholder': 'e.g. Starbucks',
    'ai.error_mandatory': 'Please select a category or enter a store name.',
    'ai.view_reasoning': '🤔 View AI Reasoning',
    'ai.store_deal': '🎯 Store Specific Deal',
    'ai.category_deal': '📂 Category Deal',
    'ai.error_target_spending': 'Target spending is mandatory. Please enter a valid amount.',
    'ai.error_no_methods': 'Please select at least one credit card or payment method.',
    'ai.error_failed': 'Recommendation failed',

    'bill.title': 'Find Best Bill Offers',
    'bill.subtitle': 'Upload your bill (PDF) and we will find the best credit card or promotion to pay it with.',
    'bill.upload_prompt': 'Click to select or drag and drop your bill (PDF only)',
    'bill.analyzing': 'Analyzing bill... Please wait.',
    'bill.details': 'Extracted Bill Details',
    'bill.company': 'Company',
    'bill.amount': 'Amount',
    'bill.due_date': 'Due Date',
    'bill.finding_offers': 'Finding the best offers...',
    'bill.best_offers': 'Recommended Offers for this Bill',
    'bill.no_offers': 'No specific bill payment offers found for this amount.',

    // Intro Carousel
    'carousel.s1_title': 'Never Miss a Deal Again',
    'carousel.s1_desc': 'Stop wasting money. Find the best credit card and store promotions in seconds.',
    'carousel.s2_title': 'Maximize Your Savings',
    'carousel.s2_desc': 'Track your spending achievements and earn extra rewards just for shopping smart.',
    'carousel.s3_title': 'Grow Your Business',
    'carousel.s3_desc': 'Reach the right customers at the right time with AI-powered targeted promotions.',
    'carousel.btn_member': 'Become a Member',
    'carousel.btn_claim': 'Claim Your Business',

    'cat_modal.title': 'Select Categories',
    'cat_modal.search_placeholder': 'Search for a category...',
    'cat_modal.loading': 'Loading categories...',
    'cat_modal.error_loading': 'Failed to load categories.',
    'cat_modal.no_results': 'No matching categories found.',
    'cat_modal.confirm_btn': 'Confirm Selection',

    // Store Modal
    'store_modal.title': 'Select Stores',
    'store_modal.search_placeholder': 'Search store by keyword...',
    'store_modal.add_btn': 'Add',
    'store_modal.filter_by_category': 'Filter by Categories:',
    'store_modal.all_categories': 'All',
    'store_modal.clear_categories': 'Clear',
    'store_modal.selected_count': 'Selected',
    'store_modal.loading': 'Loading stores...',
    'store_modal.error_loading': 'Failed to load stores.',
    'store_modal.no_stores_found': 'No stores found matching your criteria.',
    'store_modal.no_results_add_prompt': 'No existing stores found. Click \'Add\' to use "{name}".',
    'store_modal.cancel_btn': 'Cancel',
    'store_modal.confirm_btn': 'Confirm Selection',

    'cc_modal.title': 'Select Credit Cards',
    'cc_modal.filter_bank': 'Filter by Bank',
    'cc_modal.filter_issuer': 'Filter by Issuer',
    'cc_modal.all_banks': 'All Banks',
    'cc_modal.all_issuers': 'All Issuers',
    'cc_modal.search_placeholder': 'Search cards...',
    'cc_modal.no_cards': 'No credit cards found matching your criteria.',
    'cc_modal.add_custom': 'Add Custom Card:',
    'cc_modal.custom_placeholder': 'e.g. My Local Bank Card',
    'cc_modal.selected_count': 'Selected',
    'cc_modal.confirm_btn': 'Confirm Selection',
    'cc_modal.add_btn': 'Add',

    'donate.error_stripe_key_missing': 'Stripe key is missing in configuration.',
    'donate.error_min_donation': 'Minimum donation for {currency} is {minAmount}',
    'donate.error_server_confirmation': 'Payment succeeded, but server confirmation failed: {error}',
    'donate.title': 'Support SNAP PERK',
    'donate.subtitle': 'Your donation helps us maintain the platform.',
    'donate.amount_label': 'Amount ({currency})',
    'donate.min_hint': 'Min: {minAmount}',
    'donate.name_label': 'Name (Optional)',
    'donate.name_placeholder': 'Your Name',
    'donate.email_label': 'Email (Receipts)',
    'donate.email_placeholder': 'you@example.com',
    'donate.message_label': 'Message (Optional)',
    'donate.hide_name': 'Hide my name on the public list',
    'donate.processing': 'Processing...',
    'donate.donate_btn': 'Donate {currency} {amount}',
    'donate.confirming': 'Confirming...',
    'donate.confirm_payment': 'Confirm Payment',

    'donation_list.title': 'Our Supporters',
    'donation_list.subtitle': 'Thank you to everyone who has contributed to SNAP PERK.',
    'donation_list.loading': 'Loading donations...',
    'donation_list.error': 'Failed to load donations.',
    'donation_list.no_donations': 'No donations yet. Be the first to support us!',
    'donation_list.anonymous': 'Anonymous',
    'donation_list.column_date': 'Date',
    'donation_list.column_name': 'Name',
    'donation_list.column_amount': 'Amount',
    'donation_list.column_message': 'Message',
    'donation_list.back_btn': 'Make a Donation',

    // Home
    'home.active_promotions': 'Active Promotions',
    'home.sort_by': 'Sort By',
    'home.sort.newest': 'Newest',
    'home.sort.ending_soon': 'Ending Soon',
    'home.sort.name': 'Name (A-Z)',
    'home.sort.reward': 'Reward % (High to Low)',
    'home.sort.spend': 'Min. Spend (Low to High)',
    'home.loading': 'Loading promotions...',
    'home.no_data': 'No active promotions found.',
    'home.load_more': 'Load More',

    // Card
    'card.business_post': 'Business Post',
    'card.selected_member': 'Selected Member',
    'card.starts': 'Starts',
    'card.ends': 'Ends',
    'card.min_spend': 'Min. Spend',
    'card.target_spend': 'Target Spend',
    'card.up_to': 'Up to',
    'card.reward': 'Reward',
    'card.online': 'Online',
    'card.in_store': 'In-Store',
    'card.last_modified': 'Last modified by',
    'card.edit': 'Edit',
    'card.favourite': 'Favourite',
    'card.join': 'Join Challenge',
    'card.reg_req': 'Reg. Req.',
    'card.log': 'Log',

    'cardholders.back_to_promo': '← Back to Promotion',
    'cardholders.title_with_card': 'Users with {card}',
    'cardholders.subtitle': 'Connect with these users to enjoy exclusive card promotions.',
    'cardholders.loading': 'Loading users...',
    'cardholders.no_data': 'No users have listed this card yet.',
    'cardholders.anonymous': 'Anonymous User',
    'cardholders.view_profile': 'View Profile',

    // Log Transaction Modal
    'log_modal.title': 'Log Transaction',
    'log_modal.promo': 'Promotion',
    'log_modal.amount': 'Amount Spent ($)',
    'log_modal.date': 'Receipt Date',
    'log_modal.receipt': 'Upload Receipt (Optional)',
    'log_modal.submit': 'Submit Transaction',
    'log_modal.cancel': 'Cancel',
    'log_modal.error_amount': 'Please enter a valid amount.',
    'log_modal.error_failed': 'Failed to log transaction.',
    'log_modal.uploading': 'Processing...',
    'log_modal.choose_file': 'Choose File',

    'promo_detail.title': 'Promotion Details',
    'promo_detail.official_link': 'View Official Offer',
    'promo_detail.validity': 'Validity & Dates',
    'promo_detail.eligibility': 'Spending & Eligibility',
    'promo_detail.banking': 'Banks & Cards',
    'promo_detail.locations': 'Availability & Locations',
    'promo_detail.rewards': 'Reward Details',
    'promo_detail.targets': 'Challenge Targets',
    'promo_detail.eligible_days': 'Eligible Weekdays',
    'promo_detail.specific_dates': 'Specific Dates',
    'promo_detail.online_shops': 'Online Shops',
    'promo_detail.physical_stores': 'Physical Stores',
    'promo_detail.places': 'Areas / Malls',
    'promo_detail.reward_tiers': 'Tiered Rewards',
    'promo_detail.condition': 'Condition',
    'promo_detail.reward_val': 'Reward',
    'promo_detail.max_reward': 'Maximum Reward Limit',
    'promo_detail.reg_detail': 'Registration Instructions',
    'promo_detail.days.0': 'Sunday',
    'promo_detail.days.1': 'Monday',
    'promo_detail.days.2': 'Tuesday',
    'promo_detail.days.3': 'Wednesday',
    'promo_detail.days.4': 'Thursday',
    'promo_detail.days.5': 'Friday',
    'promo_detail.days.6': 'Saturday',
    'promo_detail.who_has_this_card': 'Who has this card?',

    'promotions.today_special_title': "Special Offers for Today",
    'promotions.no_specials': "No specific special offers for today. Check out our general promotions!",
    'promotions.days_label': "Eligible Days",
    'promotions.dates_label': "Specific Dates",
    'promotions.browse_all_promotions': "Browse all promotions",

    'public_profile.back_to_cardholders': '← Back to Card Holders ({card})',
    'public_profile.loading': 'Loading profile...',
    'public_profile.anonymous': 'Anonymous User',
    'public_profile.owned_cards': 'Owned Credit Cards',
    'public_profile.no_cards': 'This user has not listed any credit cards yet.',
    'public_profile.connect': 'Connect',
    'public_profile.email_address': 'Email Address',
    'public_profile.previously_unlocked': '✓ Previously Unlocked',
    'public_profile.hidden_10_credits': 'Hidden (Requires 10 Credits)',
    'public_profile.not_provided': 'Not provided by user',
    'public_profile.pay_10_reveal': 'Pay 10 Credits to Reveal',
    'public_profile.phone_im': 'Phone & Instant Messaging',
    'public_profile.hidden_20_credits': 'Hidden (Requires 20 Credits)',
    'public_profile.pay_20_reveal': 'Pay 20 Credits to Reveal',
    'public_profile.login_required': 'Please login to connect with users.',
    'public_profile.confirm_deduct': 'This will deduct {cost} credits from your balance. Proceed?',
    'public_profile.cannot_unlock_self': 'Cannot unlock own profile',

    

    'mealdeals.breakfast': 'Breakfast',
    'mealdeals.lunch': 'Lunch',
    'mealdeals.afternoon_tea': 'Afternoon Tea',
    'mealdeals.dinner': 'Dinner',
    'mealdeals.midnight_snack': 'Midnight Snack',
    'mealdeals.title': 'Time for {meal}!',
    'mealdeals.view_all': 'View All {meal} Deals &rarr;',
    'mealdeals.up_to_percent': 'Up to {reward}% Off',
    'mealdeals.save_up_to': 'Save up to ${reward}',
    'mealdeals.no_deals': 'No specific {meal} deals at the moment, but check out our other offers!',

    'partner.tagline': 'Exclusive partner offers for Snapperk members',
    'partner.loading_collections': 'Loading latest collections...',
    'partner.no_offers': 'No current offers available for {brand}.',
    'partner.fetch_error': 'Failed to load partner promotions.',
    'partner.loading_details': 'Loading details...',
    'partner.not_found': 'Promotion not found.',
    'partner.use_code': 'Use Code:',
    'partner.shop_button': 'Shop at Official Store',

    'payment_modal.title': 'Select Methods of Spending',
    'payment_modal.search_placeholder': 'Search list...',
    'payment_modal.loading': 'Loading...',
    'payment_modal.error_loading': 'Could not load payment methods.',
    'payment_modal.no_data': 'No matching methods found. Add a custom one below.',
    'payment_modal.add_custom_label': 'Add Custom Method:',
    'payment_modal.add_custom_placeholder': 'e.g. Cash',
    'payment_modal.add_btn': 'Add',
    'payment_modal.selected_count': 'Selected',
    'payment_modal.cancel_btn': 'Cancel',
    'payment_modal.confirm_btn': 'Confirm Selection',

    // --- NEW: Scan Page ---
    'scan.title': 'Add a Promotion',
    'scan.subtitle': 'Choose how you want to import details:',
    'scan.option1': 'Scan Image',
    'scan.option1_desc': 'Upload a screenshot or photo of the offer.',
    'scan.scanning': 'Scanning...',
    'scan.upload_btn': 'Upload Image',
    'scan.option2': 'Scan URL',
    'scan.option2_desc': 'Paste the link to the promotion webpage.',
    'scan.extract_btn': 'Extract from URL',
    'scan.manual_btn': 'Enter Manually',
    'scan.or': 'OR',

    'search.title': 'Search for Promotions',
    'search.keyword': 'Keyword (Name/Description)',
    'search.bank': 'Bank',
    'search.spending': 'My Spending Amount ($)',
    'search.options': 'Options',
    'search.online': 'Online',
    'search.instore': 'In-Store',
    'search.hide_filters': 'Hide Filters',
    'search.show_filters': 'Show Filters',
    'search.expired': 'Include Expired',
    'search.upcoming': 'Include Upcoming',
    'search.categories': 'Categories',
    'search.select_categories': 'Select Categories',
    'search.methods': 'Methods of Spending',
    'search.select_methods': 'Select Methods',
    'search.stores': 'Stores',
    'search.select_stores': 'Select Stores',
    'search.credit_cards': 'Credit Cards',
    'search.select_cards': 'Select Cards',
    'search.places': 'Places',
    'search.select_places': 'Select Places',
    'search.selected': 'Selected',
    'search.reset': 'Reset',
    'search.btn': 'Search',
    'search.searching': 'Searching...',
    'search.enter_criteria': 'Please enter search criteria.',
    'search.no_results': 'No promotions found matching your criteria in',
    'search.load_more': 'Load More',
    'geo.location_aware': 'Location-aware',
    'geo.beta': 'Beta',
    'geo.locating': 'Getting location...',
    'geo.location_ready': 'Location active',
    'geo.permission_denied': 'Location access denied or unavailable',
    'geo.not_supported': 'Geolocation is not supported by your browser',
    'geo.nearby': 'Nearby',
    'geo.away': 'away',

    // --- NEW: Home Tabs ---
    'tabs.promotions': 'Active Promotions',
    'tabs.products': 'Product Discounts',

    'top_savers.title': 'Top Savers',
    'top_savers.subtitle': 'The most active savers in',
    'top_savers.rank': 'Rank',
    'top_savers.user': 'User',
    'top_savers.savings': 'Total Savings',
    'top_savers.view_transactions': 'View Transactions',
    'top_savers.period.day': 'Today',
    'top_savers.period.week': 'This Week',
    'top_savers.period.month': 'This Month',
    'top_savers.period.year': 'This Year',
    'top_savers.period.all_time': 'All Time',
    'top_savers.no_data': 'No data found',

    // User Transactions Modal 
    'transactions_modal.title': 'Recent Transactions',
    'transactions_modal.date': 'Date',
    'transactions_modal.promotion': 'Promotion',
    'transactions_modal.amount': 'Amount Spent',
    'transactions_modal.reward': 'Reward',
    'transactions_modal.no_data': 'No transactions found.',
    'transactions_modal.close': 'Close',
    'transactions_modal.receipt': 'Receipt',
    'transactions_modal.status_verified': 'Verified',
    'transactions_modal.status_rejected': 'Rejected',
    'transactions_modal.status_na': 'Not Applicable',
    'transactions_modal.status_pending': 'Receipt Uploaded (Pending Review)',

    'banners.loading': 'Loading featured offers...',
    'admin.banners.title': 'Banner Management',
    'admin.banners.add': 'Add New Banner',
    'admin.banners.edit': 'Edit Banner',
    
    'admin.store.title': 'Store Name Maintenance',
    'admin.store.edit': 'Edit Store',
    'admin.store.add': 'Add New Store',
    'admin.store.name': 'Store Name',
    'admin.store.country': 'Country Code',
    'admin.store.save': 'Save Changes',
    'admin.store.add_btn': 'Add Store',
    'admin.store.bulk': 'Bulk Upload',
    'admin.store.csv_hint': 'CSV format: Header `name`, then one store per line.',
    'admin.store.upload': 'Upload CSV',
    'admin.store.uploading': 'Uploading...',
    'admin.store.existing': 'Existing Stores',
    'admin.store.none': 'No stores found.',
    'admin.store.delete_confirm': 'Are you sure you want to delete this store?',
    'admin.store.success_update': 'Store updated successfully.',
    'admin.store.success_add': 'Store added successfully.',
    'admin.store.success_delete': 'Store deleted successfully.',
    'admin.store.success_upload': 'Upload successful! {inserted} new, {updated} updated.',
    'admin.store.locations': 'Store Locations',
    'admin.store.address': 'Address',
    'admin.store.lat': 'Latitude',
    'admin.store.lng': 'Longitude',
    'admin.store.add_loc_btn': 'Add Location',
    'admin.store.no_locs': 'No physical locations added yet.',
    'admin.store.populate_title': 'Populate Stores from Web / Content',
    'admin.store.input_mode_url': 'By Web URL',
    'admin.store.input_mode_content': 'Paste Page Text / HTML',
    'admin.store.english_url': 'English Brand URL',
    'admin.store.non_english_url': 'Non-English Brand URL (e.g. Chinese)',
    'admin.store.english_content': 'English Webpage Text / HTML',
    'admin.store.non_english_content': 'Non-English Webpage Text / HTML (Optional)',
    'admin.store.content_hint': 'Tip: If a website is protected by Cloudflare (HTTP 403) like hongkongairport.com, visit the page in your browser, select all (Ctrl+A), copy, and paste here.',
    'admin.store.predefined_alias': 'Predefined Alias',
    'admin.store.predefined_categories': 'Predefined Categories',
    'admin.store.extract_save': 'Extract & Save Stores',
    'admin.store.extracting': 'Extracting...',
    'admin.store.search_placeholder': '🔍 Search stores by name or alias...',
    'admin.store.success_populate': 'Successfully populated stores! Extracted: {extracted}, Inserted: {inserted}, Skipped: {skipped}',
    'admin.store.places': 'Associated Shopping Malls / Places',
    'admin.store.no_places': 'No places registered yet. Add in Place Maintenance.',
    'admin.store.tab_directory': 'Store Directory & Editor',
    'admin.store.tab_csdi_matched': 'CSDI Location Importer (Matched)',
    'admin.store.tab_csdi_unmatched': 'Unmatched CSDI POIs',
    'admin.store.tab_track_records': 'Track Records',
    'admin.store.aliases': 'Store Aliases (comma-separated)',
    'admin.store.aliases_placeholder': 'e.g. 惠康, Wellcome Supermarket',
    'admin.store.enable_profile': 'Enable Store Profile & Brand Page',
    'admin.store.profile_hint': "Allows users to view this store's dedicated brand page and its locations.",
    'admin.store.activation_code': 'Activation Code (Store Manager Link)',
    'admin.store.generate_code': 'Generate Code',
    'admin.store.activation_code_hint': 'Share this code with the physical store merchant to bind their business account.',
    'admin.store.lookup_gps': 'Lookup GPS',
    'admin.store.searching_gps': 'Searching...',
    'admin.store.places_label': 'Places',
    'admin.store.locations_label': 'Locations',
    'admin.store.remove': 'Remove',
    'admin.store.showing_range': 'Showing {start}-{end} of {total} stores',
    'admin.store.track_title': 'Action History & Audit Logs',
    'admin.store.track_hint': 'Audit trail of all store modifications, imports, and deletions with 1-click restore.',
    'admin.store.track_filter': 'Filter by store...',
    'admin.store.restore': 'Restore to Editor',
    'admin.store.no_track_records': 'No track records found.',
    'admin.store.auto_heal_title': 'Coordinate Auto-Heal (BulkWrite)',
    'admin.store.auto_heal_desc': 'Scan and repair corrupted HK80 coordinates across Places, CSDI Records, and Stores.',
    'admin.store.auto_heal_btn': 'Run Auto-Heal',
    'admin.store.auto_heal_confirm': 'Are you sure you want to execute bulk coordinate auto-heal on MongoDB using BulkWrite?',
    'admin.store.auto_heal_running': 'Healing coordinates via BulkWrite...',
    'admin.store.auto_heal_healthy': 'All coordinates are healthy. No corrupted records detected.',
    'admin.store.auto_heal_corrupted_found': 'Found {total} records with corrupted coordinates ({places} places, {csdi} CSDI records, {stores} stores).',
    'admin.store.auto_heal_success': 'Successfully healed {total} coordinates in bulk ({places} places, {csdi} CSDI, {stores} stores).',
    'admin.store.auto_heal_refresh': 'Re-check Health',

    // CSDI Location Importer
    'admin.csdi.upload_title': 'Upload CSDI / FEHD Bulk CSV',
    'admin.csdi.upload_hint': 'Upload a bulk CSV file (e.g. 9.5MB+, 50,000+ rows) containing Hong Kong POI records. Processing runs asynchronously in background with pure mathematical coordinate projection and live progress tracking.',
    'admin.csdi.choose_csv': 'Choose CSV & Match',
    'admin.csdi.processing_bg': 'Processing in Background...',
    'admin.csdi.import_complete': 'Import Complete',
    'admin.csdi.processing_error': 'Processing Error',
    'admin.csdi.uploading_csv': 'Uploading CSV File...',
    'admin.csdi.processing_records': 'Processing CSDI Records in Background...',
    'admin.csdi.total_rows': 'Total Rows',
    'admin.csdi.processed': 'Processed',
    'admin.csdi.matched_stores': 'Matched Stores',
    'admin.csdi.high_confidence': 'High Confidence',
    'admin.csdi.unmatched_pois': 'Unmatched POIs',
    'admin.csdi.pending_review': 'Pending Review',
    'admin.csdi.high_confidence_safe': 'High Confidence (Safe)',
    'admin.csdi.needs_review': 'Needs Review',
    'admin.csdi.already_applied': 'Already Applied',
    'admin.csdi.discovered_malls_title': 'Discovered Missing Shopping Malls',
    'admin.csdi.discovered_malls_hint': 'The following shopping malls (e.g. Ho Man Tin Plaza, Telford Plaza, Fu Tung Plaza) were identified in the CSDI records but are not yet registered in your Places database. Review & add them so store locations will automatically link to them with HIGH confidence.',
    'admin.csdi.rescan_malls': 'Re-scan Malls',
    'admin.csdi.add_selected_malls': 'Add Selected to Places & Re-Match',
    'admin.csdi.adding_malls': 'Adding & Re-matching...',
    'admin.csdi.mall_name_en_zh': 'Mall Name (English & Chinese)',
    'admin.csdi.short_tag': 'Short Tag',
    'admin.csdi.district_address': 'District & Consensus Address',
    'admin.csdi.centroid_gps': 'Centroid GPS',
    'admin.csdi.detected_stores': 'Detected Stores',
    'admin.csdi.action': 'Action',
    'admin.csdi.add_and_link': 'Add & Link',
    'admin.csdi.no_gps': 'No GPS',
    'admin.csdi.scanning': 'Scanning...',
    'admin.csdi.scan_prompt': 'Missing shopping malls in CSDI? Scan to discover malls (e.g. Ho Man Tin Plaza, Telford Plaza) and add them to Places.',
    'admin.csdi.scan_btn': 'Scan for Missing Malls',
    'admin.csdi.all_stores': 'All Stores',
    'admin.csdi.status_pending': 'Pending',
    'admin.csdi.status_applied': 'Applied',
    'admin.csdi.status_rejected': 'Rejected',
    'admin.csdi.all_statuses': 'All Statuses',
    'admin.csdi.all_confidences': 'All Confidences',
    'admin.csdi.high_confidence_only': 'High Confidence Only',
    'admin.csdi.medium_confidence': 'Medium Confidence',
    'admin.csdi.low_confidence': 'Low Confidence',
    'admin.csdi.search_address_store': 'Search address / store...',
    'admin.csdi.quick_apply': 'Quick Apply High Confidence',
    'admin.csdi.apply_selected': 'Apply Selected',
    'admin.csdi.reject_selected': 'Reject Selected',
    'admin.csdi.th_store': 'Store (CSDI Name)',
    'admin.csdi.th_address': 'Detected District & Address',
    'admin.csdi.th_gps': 'Location GPS',
    'admin.csdi.th_action_override': 'Suggested Action & Mall Override',
    'admin.csdi.th_confidence_reason': 'Confidence & Reason',
    'admin.csdi.th_actions': 'Actions',
    'admin.csdi.opt_street': 'Street Shop',
    'admin.csdi.opt_mall': 'Inside Mall:',
    'admin.csdi.btn_apply': 'Apply',
    'admin.csdi.btn_reject': 'Reject',
    'admin.csdi.no_staged_records': 'No staged records found matching your filters.',
    'admin.csdi.unmatched_title': 'Unmatched CSDI POIs',
    'admin.csdi.unmatched_hint': 'The following POI records could not be automatically matched with any existing store brand in your database. You can review them, link to a shopping mall, and create a brand-new Store with 1 click.',
    'admin.csdi.unmatched_search_placeholder': 'Search unmatched POI / address...',
    'admin.csdi.btn_create_store': 'Create New Store',
    'admin.csdi.th_poi_name': 'Premises / POI Name',
    'admin.csdi.th_poi_address': 'Detected Address',
    'admin.csdi.th_poi_gps': 'GPS Coordinates',
    'admin.csdi.th_nearest_mall': 'Nearest Detected Mall',
    'admin.csdi.modal_create_store_title': 'Create New Store from CSDI Record',
    'admin.csdi.modal_create_store_hint': 'This will register a new brand in the store directory, set its initial location, and link its shopping mall relationship.',
    'admin.csdi.initial_address': 'Initial Location Address',
    'admin.csdi.associated_mall': 'Associated Shopping Mall',
    'admin.csdi.select_mall_opt': 'Select Associated Mall (Optional)',
    'admin.csdi.street_shop_none': 'Standalone Street Shop (None)',
    'admin.csdi.btn_create_link': 'Create Store & Link Location',
    'admin.csdi.creating': 'Creating...',
    'admin.place.title': 'Place / Shopping Mall Maintenance',
    'admin.place.edit': 'Edit Place',
    'admin.place.add': 'Add New Place',
    'admin.place.name': 'Place Name (Canonical / Display)',
    'admin.place.name_en': 'English Name (e.g. Times Square)',
    'admin.place.name_zh': 'Traditional Chinese Name (e.g. 時代廣場)',
    'admin.place.name_ja': 'Japanese Name (e.g. タイムズスクエア)',
    'admin.place.short_tag': 'Short Tag / Hashtag (e.g. TimesSquare)',
    'admin.place.country': 'Country Code',
    'admin.place.address': 'Address',
    'admin.place.lookup_btn': 'Lookup Coordinates',
    'admin.place.csdi_btn': 'CSDI Search',
    'admin.place.csdi_searching': 'Searching CSDI...',
    'admin.place.csdi_found': 'Auto-filled from CSDI: {name}',
    'admin.place.csdi_none': 'No matching place found on CSDI.',
    'admin.place.lat': 'Latitude',
    'admin.place.lng': 'Longitude',
    'admin.place.coordinates': 'GPS Coordinates',
    'admin.place.no_coords': 'No GPS coordinates set',
    'admin.place.save': 'Save Changes',
    'admin.place.add_btn': 'Add Place',
    'admin.place.cancel': 'Cancel',
    'admin.place.existing': 'Existing Places & Shopping Malls',
    'admin.place.none': 'No places found.',
    'admin.place.delete_confirm': 'Are you sure you want to delete this place?',
    'admin.place.success_add': 'Place added successfully.',
    'admin.place.success_update': 'Place updated successfully.',
    'admin.place.success_delete': 'Place deleted successfully.',
    'admin.place.bulk_upload': 'Bulk CSV Upload',
    'admin.place.bulk_upload_hint': 'Supported columns: name, nameZh, countryCode, shortTag, address, lat, lng (or official CSDI CSV: NAME_EN, NAME_ZH, EASTING, NORTHING).',
    'admin.place.download_template': 'Download CSV Template',
    'admin.place.upload_btn': 'Upload Places CSV',
    'admin.place.uploading': 'Uploading...',
    'admin.place.upload_success': 'Bulk upload successful! Processed: {processed}, Inserted: {inserted}, Updated: {modified}.',
    'admin.place.search_placeholder': '🔍 Search places by name, tag, or address...',
    'admin.place.showing_range': 'Showing {start}-{end} of {total} places',
    'card.code': 'Code',
    'card.max_target_transactions': 'Max Target Transactions',
    'card.max_target_spend': 'Max Target Spend',
    'card.your_reward': 'Your Reward',


    'admin.ai_models': 'AI Models',
    'admin.ai_models.title': 'AI Models Management',
    'admin.ai_models.discover_btn': 'Auto-Discover Gemini Models',
    'admin.ai_models.discover_deepseek_btn': 'Auto-Discover DeepSeek Models',
    'admin.ai_models.discovering': 'Discovering...',
    'admin.ai_models.discovering_deepseek': 'Discovering DeepSeek...',
    'admin.ai_models.models_title': 'Available AI Models',
    'admin.ai_models.failed_title': 'Recent Model Failures (15m Cooldown)',
    'admin.ai_models.table_name': 'Model ID',
    'admin.ai_models.table_provider': 'Provider',
    'admin.ai_models.table_display': 'Display Name',
    'admin.ai_models.table_status': 'Status',
    'admin.ai_models.table_actions': 'Actions',
    'admin.ai_models.table_failed_at': 'Failed At',
    'admin.ai_models.table_reason': 'Failure Reason',
    'admin.ai_models.table_priority': 'Priority',
    'admin.ai_models.status_enabled': 'Enabled',
    'admin.ai_models.status_disabled': 'Disabled',
    'admin.ai_models.btn_enable': 'Enable',
    'admin.ai_models.btn_disable': 'Disable',
    'admin.ai_models.btn_clear_fail': 'Clear Failure',
    'admin.ai_models.no_failed_models': 'No failed models currently recorded.',
    'admin.ai_models.no_models': 'No models found. Run auto-discovery above.',

    'admin.ai_tasks': 'AI Task Configs',
    'admin.ai_tasks.title': 'AI Task Configurations',
    'admin.ai_tasks.subtitle': 'Manage AI model pipelines and timeouts per workload. AI models are dynamically selected from enabled models in the AI Models registry.',
    'admin.ai_tasks.tab_models': 'AI Models Registry',
    'admin.ai_tasks.tab_tasks': 'Task Configurations',
    'admin.ai_tasks.select_task': 'Select AI Task',
    'admin.ai_tasks.task_name': 'Task',
    'admin.ai_tasks.task_desc': 'Description',
    'admin.ai_tasks.timeout': 'Timeout (Seconds)',
    'admin.ai_tasks.model_pipeline': 'Model Priority Pipeline',
    'admin.ai_tasks.pipeline_hint': 'Requests will attempt models in order from top to bottom. If a model fails or times out, the next model will be used.',
    'admin.ai_tasks.add_model': 'Add Model to Pipeline',
    'admin.ai_tasks.select_model': '-- Select an enabled model --',
    'admin.ai_tasks.no_enabled_models': 'No enabled models available to add.',
    'admin.ai_tasks.move_up': 'Move Up',
    'admin.ai_tasks.move_down': 'Move Down',
    'admin.ai_tasks.remove': 'Remove',
    'admin.ai_tasks.save': 'Save Configuration',
    'admin.ai_tasks.saving': 'Saving...',
    'admin.ai_tasks.save_success': 'Task configuration updated successfully.',
    'admin.ai_tasks.save_error': 'Failed to save task configuration.',
    'admin.ai_tasks.task_recommendation': 'Promotion Recommendation',
    'admin.ai_tasks.task_image_scanning': 'Image Scanning & OCR',
    'admin.ai_tasks.empty_pipeline': 'No models in pipeline. Add at least one enabled model.',
    'admin.ai_tasks.fast_multimodal_hint': 'Ultra-fast multimodal models (e.g., gemini-2.5-flash) are recommended at the top of the pipeline for rapid OCR.',
    'admin.ai_tasks.seed_fast_models': 'Reset to Recommended Fast Models',
    'admin.ai_tasks.seed_fast_models_confirm': 'Reset the image scanning pipeline to recommended fast multimodal models?',

    // Admin System Settings
    'admin.cron_jobs': 'Cron & Recurring Jobs',
    'admin.system_settings': 'System Settings',
    'admin.system_settings.title': 'Content Moderation & Anti-Spam Settings',
    'admin.system_settings.subtitle': 'Configure thresholds for image quality checks, spam detection, and repeat offender bans.',
    'admin.system_settings.blur_threshold': 'Blur Sharpness Threshold (Laplacian Variance)',
    'admin.system_settings.blur_hint': 'Images with variance below this threshold are flagged as blurry (Default: 90.0).',
    'admin.system_settings.blank_threshold': 'Blank Image Luminance Variance Threshold',
    'admin.system_settings.blank_hint': 'Images with luminance std dev below this threshold are flagged as blank/solid (Default: 8.0).',
    'admin.system_settings.spam_ban_threshold': 'Spam Strike Limit before 24h Ban',
    'admin.system_settings.spam_hint': 'Number of rejected promotions before the user is automatically banned from posting for 24 hours (Default: 3).',
    'admin.system_settings.ban_duration': 'Ban Duration (Hours)',
    'admin.system_settings.ban_duration_hint': 'Duration of posting ban when strike limit is reached (Default: 24).',
    'admin.system_settings.radius_title': 'Nearby & Live Location Search Radius (km)',
    'admin.system_settings.radius_hint': 'Default search radius for "Near Me" promotions, live location toggle, and mall hashtag discovery (Default: 2.0 km).',
    'admin.system_settings.geofence_limit': 'Geofence Verification Distance Limit (Meters)',
    'admin.system_settings.geofence_hint': 'Maximum allowed distance between user GPS and store GPS when verifying in-store promotion submissions (Default: 200m).',
    'admin.system_settings.duplicate_hamming_threshold': 'Duplicate Image Hamming Distance Threshold',
    'admin.system_settings.duplicate_hamming_hint': 'Maximum perceptual hash Hamming distance (0–16) to consider two images near-duplicates. Lower values reduce false positives (Default: 3).',
    'admin.system_settings.trusted_template_providers': 'Trusted Template Providers (Comma-Separated)',
    'admin.system_settings.trusted_template_providers_hint': 'Payment platforms or digital wallets where UI screenshots share standard layouts (e.g. PayMe, AlipayHK, WeChat Pay). Near-duplicate image matches will be allowed if the promotion title or dates are different.',
    'admin.system_settings.save': 'Save Settings',
    'admin.system_settings.saving': 'Saving...',
    'admin.system_settings.save_success': 'System moderation settings saved successfully.',
    'admin.system_settings.save_error': 'Failed to save system settings.',

    // Admin Users Ban Management
    'admin.users.ban_status': 'Post Ban Status',
    'admin.users.banned_until': 'Banned until',
    'admin.users.unban': 'Lift Ban',
    'admin.users.unban_confirm': 'Are you sure you want to lift the promotion posting ban for this user?',
    'admin.users.unbanned_success': 'User posting ban lifted successfully.',
    'admin.users.clean_status': 'Clean',
    'admin.users.strikes': 'Active Strikes',
    'admin.users.ban_history': 'Ban History',
    'admin.users.no_ban_history': 'No ban history recorded.',

    // Promotion Lifecycle: Ban & Delete
    'promo.ban_btn': 'Ban Promotion',
    'promo.ban_confirm': 'Are you sure you want to ban this promotion? It will be hidden from public searches.',
    'promo.ban_reason_prompt': 'Enter ban reason (optional):',
    'promo.banned_success': 'Promotion has been banned.',
    'promo.delete_btn': 'Delete Promotion',
    'promo.delete_confirm': 'Are you sure you want to delete this promotion? This action cannot be undone.',
    'promo.delete_success': 'Promotion deleted successfully.',
    'promo.error.cannot_delete_has_challenges': 'Cannot delete promotion because users have joined active challenges or achievements for it.',
    'promo.error.banned': 'Your account is temporarily banned from posting promotions until {date} due to repeated quality/spam violations.',
    'promo.error.dummy_text': 'Please provide a valid promotion title and description.',
    'promo.error.blank_image': 'The selected image appears to be blank or solid color. Please upload a clear photo.',
    'promo.error.blurry_image': 'The image is too blurry to read. Please upload a clearer photo.',
    'promo.error.sensitive_info': 'Promotions containing sensitive information (such as credit card details or identity documents) cannot be submitted.',

    'common.prev': 'Prev',
    'common.next': 'Next',
    'common.page': 'Page',
    'common.of': 'of',
    'common.page_of': 'Page {page} of {total}',
    'common.cancel': 'Cancel',
    'common.edit': 'Edit',
    'common.delete': 'Delete',
    'common.loading': 'Loading...',

    // Admin Banned Promotions
    'admin.promotions': 'Promotions & SEO Guides',
    'admin.banned_promotions': 'Banned Promotions',
    'admin.banned_promos.title': 'Banned Promotions',
    'admin.banned_promos.subtitle': 'Review and manage promotions that have been banned or rejected.',
    'admin.banned_promos.promo_name': 'Promotion Name',
    'admin.banned_promos.author': 'Author',
    'admin.banned_promos.created_at': 'Creation Date & Time',
    'admin.banned_promos.verification_status': 'Verification Status',
    'admin.banned_promos.rejection_reason': 'Rejection Reason',
    'admin.banned_promos.actions': 'Actions',
    'admin.banned_promos.unban_btn': 'Unban',
    'admin.banned_promos.unbanning': 'Unbanning...',
    'admin.banned_promos.unban_confirm': 'Are you sure you want to unban this promotion? It will become active and verified.',
    'admin.banned_promos.unban_success': 'Promotion unbanned successfully.',
    'admin.banned_promos.unban_failed': 'Failed to unban promotion.',
    'admin.banned_promos.no_data': 'No banned promotions found.',
    'admin.banned_promos.unknown_author': 'Unknown',

    // Tax Calculator
    'tax.fab_title': 'Tax Rebate',
    'tax.fab_subtitle': 'Calculator',
    'tax.fab_dismiss': 'Dismiss for session',
    'tax.banner_title': 'Tax Rebate Calculator',
    'tax.banner_subtitle': 'Maximize your tax payment rebate with credit card & platform deals in Hong Kong',
    'tax.section1_title': '1. REBATE PREFERENCE',
    'tax.pref_cash': 'Cash Rebate ($)',
    'tax.pref_cash_desc': 'Statement rebate & cash vouchers',
    'tax.pref_miles': 'Air Miles (Miles)',
    'tax.pref_miles_desc': 'Asia Miles & frequent flyer points',
    'tax.section2_title': '2. TOTAL TAX AMOUNT',
    'tax.section3_title': '3. INSTALLMENTS (OPTIONAL)',
    'tax.pay_installments': 'Pay in Installments',
    'tax.installment_schedule_subtitle': 'Installment Breakdown Schedule:',
    'tax.split_2': 'Split 2',
    'tax.split_3': 'Split 3',
    'tax.add_installment': '+ Add',
    'tax.installment_sum_matched': '✓ Installments equal total tax: HK$ {sum}',
    'tax.installment_diff': '⚠️ Difference: HK$ {diff} ({reason})',
    'tax.exceeds_tax': 'Exceeds total tax',
    'tax.remaining_unallocated': 'Remaining unallocated',
    'tax.section4_title': '4. TAX REBATE PROMOTIONS',
    'tax.cross_promotion': 'Cross-Promotion Optimization',
    'tax.promos_selected': '{selected}/{total} Promotions Selected',
    'tax.select_all': 'Select All',
    'tax.clear': 'Clear',
    'tax.same_bank_warning': 'Each customer might enjoy only 1 tax rebate promotion on the same bank/platform ({bank}).',
    'tax.promo_expires_warning': '{brand} expires before one of your scheduled installments.',
    'tax.loading_promos': 'Loading Tax Rebate offers...',
    'tax.empty_promos_msg': 'We are working hard on loading tax rebate promotions, you can helpus too',
    'tax.add_promo_btn': '+ Add New Promotion',
    'tax.air_miles_promo': 'Air Miles Promotion',
    'tax.cash_rebate_promo': 'Cash Rebate Promotion',
    'tax.calculate_btn': 'Calculate Tax Rebate',
    'tax.share_card.tagline': 'Tax Rebate Optimizer',
    'tax.share_card.total_tax': 'TOTAL TAX AMOUNT',
    'tax.share_card.optimized_rebate': 'OPTIMIZED REBATE',
    'tax.share_card.best_rebate': 'BEST REBATE',
    'tax.share_card.installment_schedule': 'INSTALLMENT SCHEDULE',
    'tax.share_card.allocation_strategy': 'ALLOCATION STRATEGY',
    'tax.share_card.installment_item': 'Installment #{index} (HK$ {amount})',
    'tax.share_card.due_date': 'Due: {date}',
    'tax.share_card.watermark': 'Calculated with SnapPerk | Hong Kong\'s Smartest Promotion Engine',
    'tax.share_card.copied': '✓ Copied Summary',
    'tax.share_card.share': '📤 Share Summary',
    'tax.share_card.summary_title': '🌟 SNAP PERK Tax Rebate Summary',
    'tax.share_card.calculated_on': '📅 Calculated on: {date}',
    'tax.share_card.total_tax_line': '💰 Total Tax: HK${tax}',
    'tax.share_card.max_rebate_line': '🎯 Maximum Rebate: {rebate}',
    'tax.share_card.strategy_header': '📋 Strategy:',
    'tax.share_card.installment_header': '📋 Installment Breakdown:',
    'tax.share_card.installment_row': '• Installment #{index}: HK${amount}{due} => Rebate: {rebate}',
    'tax.share_card.cta': '🚀 Calculate your credit card tax rebates on SNAP PERK: https://www.snapperk.app/tax-calculator',
    'tax.tiered_rebate': 'Tiered rebate',
    'tax.min_spend': 'Min spend',
    'tax.fixed_rebate': 'Fixed rebate',
    'tax.rebate': 'rebate',
    'tax.capped_at': 'Capped at',
    'tax.tier_reached': 'Tier reached',
    'tax.no_additional_rebate': 'No additional rebate (below threshold)',
    'tax.below_min_spend': 'Below minimum spending ({amount})',
    'tax.hit_max_cap': 'Hit max cap {amount}',
    'tax.fixed_reward_reached': 'Fixed reward reached ({amount})',
    'tax.promo_expired_due_date': 'Promotion expired before due date',
    'tax.miles_2k_reward': '2,000 miles (requires HK$3,000 retail spend)',
    'tax.miles_4k_reward': '4,000 miles (requires HK$20,000 retail spend)',
    'tax.below_min_miles_spend': 'Below minimum miles spending (HK$3,000)',
    'tax.miles_bea_desc': '2,000 miles (retail spend HK$3k) or 4,000 miles (retail spend HK$20k)',
    'tax.spend_x_for_y_rebate': 'Spend {spend} for {rebate} rebate',

    // Open Account Calculator
    'open_account.fab_title': 'Open Account',
    'open_account.fab_subtitle': 'Reward Calc',
    'open_account.fab_dismiss': 'Dismiss for session',
    'open_account.banner_title': 'Open Account Reward Calculator',
    'open_account.banner_subtitle': 'Maximize welcome rewards by splitting new money across bank promotions in Hong Kong',
    'open_account.section1_title': '1. REBATE PREFERENCE',
    'open_account.pref_cash': 'Cash Rebate ($)',
    'open_account.pref_cash_desc': 'Cash credit, statement rebate & vouchers',
    'open_account.pref_miles': 'Air Miles (Miles)',
    'open_account.pref_miles_desc': 'Asia Miles & frequent flyer points',
    'open_account.section2_title': '2. NEW MONEY AMOUNT',
    'open_account.new_money_label': 'Total New Money Amount (HK$)',
    'open_account.section3_title': '3. OPEN ACCOUNT PROMOTIONS',
    'open_account.cross_promotion': 'Cross-Promotion Optimization',
    'open_account.cross_promotion_desc': 'Split new money across accounts to maximize combined welcome rewards',
    'open_account.promos_selected': '{selected}/{total} Promotions Selected',
    'open_account.select_all': 'Select All',
    'open_account.clear': 'Clear',
    'open_account.same_bank_warning': 'Only 1 account tier can be opened per bank ({bank}).',
    'open_account.loading_promos': 'Loading Open Account offers...',
    'open_account.empty_promos_msg': 'We are working hard on adding open account related promotions',
    'open_account.add_promo_btn': '+ Add New Promotion',
    'open_account.calculate_btn': 'Calculate Best Mix',
    'open_account.share_card.tagline': 'Open Account Reward Optimizer',
    'open_account.share_card.total_money': 'TOTAL NEW MONEY',
    'open_account.share_card.allocated': 'ALLOCATED DEPOSIT',
    'open_account.share_card.unallocated': 'REMAINING UNALLOCATED',
    'open_account.share_card.optimized_reward': 'OPTIMIZED REWARD',
    'open_account.share_card.best_reward': 'BEST REWARD',
    'open_account.share_card.allocation_strategy': 'OPTIMAL SPLIT STRATEGY',
    'open_account.share_card.single_comparison': 'SINGLE ACCOUNT COMPARISON',
    'open_account.share_card.single_comparison_desc': 'If 100% of new money is placed into a single bank account',
    'open_account.share_card.gain_vs_single': '+{gain} (+{percent}%) vs best single account',
    'open_account.share_card.deposit_req': 'Deposit HK${amount}',
    'open_account.share_card.watermark': "Calculated with SnapPerk | Hong Kong's Smartest Promotion Engine",
    'open_account.share_card.copied': '✓ Copied Summary',
    'open_account.share_card.share': '📤 Share Summary',
    'open_account.share_card.summary_title': '🌟 SNAP PERK Open Account Reward Summary',
    'open_account.share_card.calculated_on': '📅 Calculated on: {date}',
    'open_account.share_card.total_line': '💰 Total New Money: HK${money}',
    'open_account.share_card.allocated_line': '🏦 Allocated Deposit: HK${amount}',
    'open_account.share_card.unallocated_line': '💵 Remaining Unallocated: HK${amount}',
    'open_account.share_card.max_reward_line': '🎯 Maximum Reward: {reward}',
    'open_account.share_card.strategy_header': '📋 Optimal Split Strategy:',
    'open_account.share_card.account_row': '• {bank} ({name}): Deposit HK${amount} => Reward: {reward}',
    'open_account.share_card.cta': '🚀 Optimize your new money deposit across HK banks on SNAP PERK: https://www.snapperk.app/open-account-calculator',
    'open_account.deposit_x_for_y': 'Deposit {deposit} for {reward} reward',

    // Handy Tools
    'tools.title': 'Handy Tools',
    'tools.subtitle': 'Dedicated calculators and tools to maximize your financial rewards',
    'tools.coming_soon': 'Coming Soon',
    'tools.open_tool': 'Open Calculator',
    'tools.tax_title': 'Tax Rebate Calculator',
    'tools.tax_desc': 'Maximize tax payment rebate with credit card & platform deals in Hong Kong',
    'tools.open_account_title': 'Open Account Reward Calculator',
    'tools.open_account_desc': 'Split new money across bank promotions to maximize combined welcome rewards',
    'tools.time_deposit_title': 'Time Deposit Rate Optimizer',
    'tools.time_deposit_desc': 'Compare and maximize interest returns on fixed term deposits across HK banks',
    'tools.spending_split_title': 'Milestone Spending Split Optimizer',
    'tools.spending_split_desc': 'Split large purchases across cards to hit milestone perks & welcome bonuses',
    'tools.air_miles_title': 'Air Miles vs Cash Valuator',
    'tools.air_miles_desc': 'Calculate the real cash equivalence of Asia Miles & frequent flyer points',
    'tools.stay_tuned': 'This dedicated tool is currently under development. Stay tuned!'
  },
  'zh-HK': {
    // Nav
    'nav.home': '主頁',
    'nav.search': '搜尋推廣',
    'nav.search_products': '格價',
    'nav.add': '新增推廣',
    'nav.scan': '掃描推廣',
    'nav.scan_product': '掃描產品',
    'nav.contact': '聯絡我們',
    'nav.my_space': '我的空間',
    'nav.my_dashboard': '我的儀表板',
    'nav.my_promotions': '我的推廣',
    'nav.my_inbox': '我的收件箱',
    'nav.my_favourites': '我的收藏',
    'nav.my_achievements': '我的成就',
    'nav.memberships': '會員計劃',
    'nav.business_plans': '商業計劃',
    'nav.admin': '管理員',
    'nav.business_tools': '商業工具',
    'nav.business_profile': '商戶資料',
    'nav.premise_mgmt': '店舖管理',
    'nav.claim_premise': '認領店舖',
    'nav.add_simple_promo': '新增簡易推廣',
    'nav.target_audience': '目標受眾',
    'nav.total_saved': '全網節省總額',
    'nav.welcome': '歡迎',
    'nav.logout': '登出',
    'nav.login': '註冊 / 登入',
    'nav.market': '市集',
    'nav.donate': '捐贈',
    'nav.bill_analyzer': '賬單分析',
    'nav.tax_calculator': '交稅回贈',
    'nav.handy_tools': '實用工具',
    'nav.open_account_calculator': '迎新開戶',
    'nav.it': 'i.t',
    'nav.card_holders': 'Card Holders', // to do
    'nav.today_special': "今日精選",
    'nav.dev_portal': '開發人員入口',
    'nav.erd': '實體關係圖',
    'erd.title': '開發人員 ERD 可視化工具',
    'erd.subtitle': '動態解析 Go 後端 handlers.go 結構體生成',
    'erd.btn_test_render': '🧪 測試簡易渲染',
    'erd.btn_refresh': '🔄 重新整理',
    'erd.btn_view_code': '💻 檢視程式碼',
    'erd.btn_view_diagram': '👁️ 檢視圖表',
    'erd.btn_copy_code': '📋 複製程式碼',
    'erd.filter_entities': '過濾實體',
    'erd.select_all': '全選',
    'erd.clear_all': '全部清除',
    'erd.loading': '正在解析 handlers.go 結構體並建立圖表...',
    'erd.copied_msg': 'Mermaid 語法已複製到剪貼簿！',

    // Consent
    'nav.consent_pre': '繼續即代表您同意我們的',
    'nav.terms': '服務條款',
    'nav.consent_mid': '並確認我們的',
    'nav.privacy': '私隱政策',
    'nav.consent_post': '。',

    // Admin
    'admin.subscriptions': '所有訂閱',
    'admin.users': '用戶',
    'admin.messages': '客戶訊息',
    'admin.messages.review_title': '審核訊息',
    'admin.messages.from': '來自',
    'admin.messages.user_profile': '用戶檔案',
    'admin.messages.member': '會員',
    'admin.messages.phone': '電話',
    'admin.messages.date': '日期',
    'admin.messages.message_label': '訊息',
    'admin.messages.admin_remarks': '管理員備註',
    'admin.messages.internal_notes_placeholder': '內部備忘...',
    'admin.messages.cancel': '取消',
    'admin.messages.close_ticket': '關閉工單',
    'admin.messages.reopen_ticket': '重新開啟工單',
    'admin.messages.title': '客戶訊息',
    'admin.messages.open': '開啟',
    'admin.messages.closed': '已關閉',
    'admin.messages.loading': '載入中...',
    'admin.messages.no_open_messages': '未找到開啟的訊息。',
    'admin.messages.no_closed_messages': '未找到已關閉的訊息。',
    'admin.messages.update_failed': '更新失敗',
    'admin.reports': '舉報問題',
    'admin.logs.title': 'API 系統日誌',
    'admin.logs.subtitle': '排查後端處理程序（例如賬單上載）。',
    'admin.logs.loading': '正在載入日誌...',
    'admin.logs.no_data': '未找到日誌。',
    'admin.logs.time': '時間',
    'admin.logs.endpoint': '終端節點',
    'admin.logs.status': '狀態',
    'admin.logs.ip_address': 'IP 地址',
    'admin.logs.user_id': '用戶 ID',
    'admin.logs.message': '訊息',
    'admin.logs.action': '操作',
    'admin.logs.details': '詳情',
    'admin.logs.prev': '上一頁',
    'admin.logs.next': '下一頁',
    'admin.logs.page_of': '第 {page} 頁，共 {totalPages} 頁',
    'admin.logs.details_title': '日誌詳情',
    'admin.logs.status_label': '狀態：',
    'admin.logs.time_label': '時間：',
    'admin.logs.endpoint_label': '終端節點：',
    'admin.logs.ip_label': 'IP 地址：',
    'admin.logs.user_id_label': '用戶 ID：',
    'admin.logs.message_label': '訊息：',
    'admin.logs.payload_label': '載荷 / 原始響應：',
    'admin.logs.no_payload': '沒有記錄載荷。',
    'admin.logs.filters.title': '篩選器',
    'admin.logs.filters.start_date': '開始日期和時間',
    'admin.logs.filters.end_date': '結束日期和時間',
    'admin.logs.filters.endpoint': '終端 URL',
    'admin.logs.filters.status': '狀態碼',
    'admin.logs.filters.ip': 'IP 地址',
    'admin.logs.filters.user_id': '用戶 ID',
    'admin.logs.filters.ai_version': 'AI 模型版本',
    'admin.logs.filters.btn_filter': '應用篩選',
    'admin.logs.filters.btn_clear': '清除篩選',
    'admin.banks': '銀行',
    'admin.banks.title': '銀行主檔清單',
    'admin.banks.add_bank': '新增銀行',
    'admin.banks.edit_bank': '編輯銀行',
    'admin.banks.add_new_bank': '新增銀行',
    'admin.banks.bank_name_en': '標準名稱（英文）',
    'admin.banks.bank_name_zh': '繁體中文',
    'admin.banks.bank_name_ja': '日本語',
    'admin.banks.bank_key': '識別鍵 (Key)',
    'admin.banks.country': '國家/地區代碼',
    'admin.banks.save_changes': '儲存變更',
    'admin.banks.cancel': '取消',
    'admin.banks.bulk_upload': '批次上傳',
    'admin.banks.bulk_upload_hint': 'CSV 格式：name,country,nameZh,nameJa,key',
    'admin.banks.upload_csv': '上傳 CSV',
    'admin.banks.uploading': '上傳中...',
    'admin.banks.existing_banks': '現有銀行 ({count})',
    'admin.banks.delete_confirm': '確定要刪除此銀行嗎？',
    'admin.banks.save_success': '銀行新增成功。',
    'admin.banks.update_success': '銀行更新成功。',
    'admin.banks.delete_success': '銀行刪除成功。',
    'admin.banks.upload_success': '批次上傳成功！已新增 {count} 間銀行。',
    'admin.banks.no_banks': '未找到任何銀行。',
    'admin.banks.loading': '載入中...',
    'admin.banks.actions': '操作',
    'admin.banks.edit': '編輯',
    'admin.banks.delete': '刪除',
    'admin.credit_cards': '信用卡',
    'admin.credit_cards.title': '信用卡主列表',
    'admin.credit_cards.short_tag': '簡稱標籤',
    'admin.credit_cards.aliases': '別名 (以逗號分隔)',
    'admin.credit_cards.aliases_label': '別名',
    'admin.credit_cards.bank_name': '銀行名稱',
    'admin.credit_cards.card_name': '信用卡名稱',
    'admin.credit_cards.issuer': '發卡機構',
    'admin.credit_cards.country': '國家/地區',
    'admin.credit_cards.active': '已啟用',
    'admin.credit_cards.actions': '操作',
    'admin.credit_cards.add_card': '新增信用卡',
    'admin.credit_cards.option_ai': '選項 1：從網站匯入 (AI)',
    'admin.credit_cards.option_csv': '選項 2：批次 CSV 上傳',
    'admin.credit_cards.option_manual': '選項 3：手動輸入',
    'admin.credit_cards.url_placeholder': '在此貼上銀行信用卡網頁 URL...',
    'admin.credit_cards.extract_btn': '擷取信用卡',
    'admin.credit_cards.extracting_btn': '掃描中...',
    'admin.credit_cards.upload_csv_btn': '上傳 CSV',
    'admin.credit_cards.save_success': '信用卡新增成功。',
    'admin.credit_cards.update_success': '信用卡更新成功。',
    'admin.credit_cards.delete_confirm': '確定要刪除此信用卡嗎？',
    'admin.credit_cards.staging_title': '檢查並儲存 ({count})',
    'admin.credit_cards.all_cards': '所有信用卡',
    'admin.credit_cards.loading': '載入列表中...',
    'admin.payment_methods': '付款方式',
    'admin.stores': '商店',
    'admin.places': '地點維護',
    'admin.questions': '問題',
    'admin.categories': '類別',
    'admin.category_name_en': '標準名稱（英文）',
    'admin.category_name_zh': '繁體中文',
    'admin.category_name_ja': '日本語',
    'admin.category_key': '識別鍵',
    'admin.category_normalize_btn': '拆分並標準化類別',
    'admin.category_normalize_confirm': '這將把中英結合的類別名稱拆分為獨立欄位並標準化所有優惠。是否繼續？',
    'admin.category_normalized_success': '類別及優惠已成功標準化！',
    'admin.invite': '建立邀請',
    'admin.web_scraper': "網頁爬蟲",
    'admin.missing_formulas': '缺少公式',
    'admin.broadcast_message': '廣播訊息',
    'admin.receipt_verification': '收據核實',
    'admin.api_logs': '系統 API 日誌',
    'admin.recommendation_logs': '推薦日誌',
    'admin.search_logs': '搜尋日誌',
    'admin.banners': '橫幅廣告',
    'admin.campaign': '活動管理',
    'admin.rewards': '可兌換獎賞',
    'admin.ai_models': 'AI 模型管理',
    'admin.ai_models.title': 'AI 模型管理',
    'admin.ai_models.discover_btn': '自動探測 Gemini 模型',
    'admin.ai_models.discover_deepseek_btn': '自動探測 DeepSeek 模型',
    'admin.ai_models.discovering': '探測中...',
    'admin.ai_models.discovering_deepseek': '探測 DeepSeek 中...',
    'admin.ai_models.models_title': '可用 AI 模型',
    'admin.ai_models.failed_title': '最近失敗模型記錄',
    'admin.ai_models.table_name': '模型 ID / 名稱',
    'admin.ai_models.table_provider': '供應商',
    'admin.ai_models.table_display': '顯示名稱',
    'admin.ai_models.table_status': '狀態',
    'admin.ai_models.table_actions': '操作',
    'admin.ai_models.table_failed_at': '失敗時間',
    'admin.ai_models.table_reason': '失敗原因',
    'admin.ai_models.table_priority': '優先級',
    'admin.ai_models.status_enabled': '已啟用',
    'admin.ai_models.status_disabled': '已停用',
    'admin.ai_models.btn_enable': '啟用',
    'admin.ai_models.btn_disable': '停用',
    'admin.ai_models.btn_clear_fail': '清除失敗記錄',
    'admin.ai_models.no_failed_models': '暫無失敗的模型記錄。',
    'admin.ai_models.no_models': '未找到模型。請執行自動探測。',
    'rewards.out_of_stock': '已售罄',

     // Admin Receipt Verification
    'admin.receipts.title': '收據審核',
    'admin.receipts.user': '用戶',
    'admin.receipts.promotion': '推廣',
    'admin.receipts.date': '日期',
    'admin.receipts.amount': '金額',
    'admin.receipts.status_verified': '已核實',
    'admin.receipts.status_rejected': '已拒絕',
    'admin.receipts.status_na': '不適用',
    'admin.receipts.status_pending': '待審核',
    'admin.receipts.btn_verify': '核實',
    'admin.receipts.btn_reject': '拒絕',
    'admin.receipts.btn_na': '不適用',
    'admin.receipts.no_data': '沒有需要審核的收據。',

    'ai.title': 'AI 智能推薦',
    'ai.desc': '告訴我們您的預計消費金額，我們的 AI 將為您計算哪張信用卡能為您帶來最大的回贈。',
    'ai.categories': '類別',
    'ai.select_categories': '選擇類別',
    'ai.target_spending': '目標消費金額 ($) *',
    'ai.using_cards': '使用信用卡：',
    'ai.using_payment_methods': '使用付款方式：',
    'ai.none_found': '沒有找到信用卡。請在個人檔案中新增。',
    'ai.thinking': '思考中...',
    'ai.get_recommendation': '獲取推薦',
    'ai.top_pick': '最佳選擇：',
    'ai.estimated_reward': '預計回贈：',
    'ai.no_suitable': '沒有找到適合此消費的推廣活動。',
    'ai.more': '張',
    'ai.store_name': '商店名稱',
    'ai.store_placeholder': '例如: Starbucks',
    'ai.error_mandatory': '請選擇類別或輸入商店名稱。',
    'ai.view_reasoning': '🤔 查看 AI 分析',
    'ai.store_deal': '🎯 指定商店優惠',
    'ai.category_deal': '📂 類別精選優惠',
    'ai.error_target_spending': '必須輸入目標消費金額。請輸入有效金額。',
    'ai.error_no_methods': '請選擇最少一張信用卡或一種付款方式。',
    'ai.error_failed': '推薦失敗',

    'bill.title': '尋找最佳繳費優惠',
    'bill.subtitle': '上傳您的賬單 (PDF)，我們將為您尋找最佳的信用卡或繳費推廣。',
    'bill.upload_prompt': '點擊選擇或拖放您的賬單 (僅限 PDF)',
    'bill.analyzing': '正在分析賬單... 請稍候。',
    'bill.details': '賬單資料',
    'bill.company': '公司名稱',
    'bill.amount': '金額',
    'bill.due_date': '到期日',
    'bill.finding_offers': '正在尋找最佳優惠...',
    'bill.best_offers': '為此賬單推薦的優惠',
    'bill.no_offers': '未能找到適合此金額的特定繳費優惠。',

    // Intro Carousel
    'carousel.s1_title': '不再錯過任何優惠',
    'carousel.s1_desc': '精明消費。幾秒鐘內找到最好的信用卡和商店推廣。',
    'carousel.s2_title': '最大化您的節省',
    'carousel.s2_desc': '追蹤您的消費成就，精明購物即可獲得額外獎勵。',
    'carousel.s3_title': '發展您的業務',
    'carousel.s3_desc': '利用 AI 驅動的目標推廣，在對的時間接觸對的客戶。',
    'carousel.btn_member': '成為會員',
    'carousel.btn_claim': '認領您的業務',

    'cat_modal.title': '選擇類別',
    'cat_modal.search_placeholder': '搜尋類別...',
    'cat_modal.loading': '載入中...',
    'cat_modal.error_loading': '載入類別失敗。',
    'cat_modal.no_results': '找不到符合條件的類別。',
    'cat_modal.confirm_btn': '確認選擇',

    // Store Modal
    'store_modal.title': '選擇商店',
    'store_modal.search_placeholder': '按關鍵字搜尋商店...',
    'store_modal.add_btn': '新增',
    'store_modal.filter_by_category': '按類別篩選：',
    'store_modal.all_categories': '全部',
    'store_modal.clear_categories': '清除篩選',
    'store_modal.selected_count': '已選',
    'store_modal.loading': '載入商店中...',
    'store_modal.error_loading': '無法載入商店。',
    'store_modal.no_stores_found': '找不到符合條件的商店。',
    'store_modal.no_results_add_prompt': '找不到現有商店。點擊「新增」以使用「{name}」。',
    'store_modal.cancel_btn': '取消',
    'store_modal.confirm_btn': '確認選擇',

    'cc_modal.title': '選擇信用卡',
    'cc_modal.filter_bank': '按銀行篩選',
    'cc_modal.filter_issuer': '按發卡機構篩選',
    'cc_modal.all_banks': '所有銀行',
    'cc_modal.all_issuers': '所有發卡機構',
    'cc_modal.search_placeholder': '搜尋信用卡...',
    'cc_modal.no_cards': '找不到符合條件的信用卡。',
    'cc_modal.add_custom': '新增自訂信用卡：',
    'cc_modal.custom_placeholder': '例如：我的本地銀行卡',
    'cc_modal.selected_count': '已選',
    'cc_modal.confirm_btn': '確認選擇',
    'cc_modal.add_btn': '新增',

    'donate.error_stripe_key_missing': '配置中缺少 Stripe 密鑰。',
    'donate.error_min_donation': '{currency} 的最低捐款額為 {minAmount}',
    'donate.error_server_confirmation': '付款成功，但伺服器確認失敗：{error}',
    'donate.title': '支持 SNAP PERK',
    'donate.subtitle': '您的捐款有助我們維持平台的運作。',
    'donate.amount_label': '金額 ({currency})',
    'donate.min_hint': '最低：{minAmount}',
    'donate.name_label': '姓名 (選填)',
    'donate.name_placeholder': '您的姓名',
    'donate.email_label': '電郵 (接收收據)',
    'donate.email_placeholder': 'you@example.com',
    'donate.message_label': '留言 (選填)',
    'donate.hide_name': '在公開名單上隱藏我的名字',
    'donate.processing': '處理中...',
    'donate.donate_btn': '捐款 {currency} {amount}',
    'donate.confirming': '確認中...',
    'donate.confirm_payment': '確認付款',

    'donation_list.title': '我們的支持者',
    'donation_list.subtitle': '感謝每一位支持 SNAP PERK 的捐款者。',
    'donation_list.loading': '載入捐款名單中...',
    'donation_list.error': '無法載入捐款名單。',
    'donation_list.no_donations': '目前尚未有捐款。成為第一位支持我們的人吧！',
    'donation_list.anonymous': '匿名',
    'donation_list.column_date': '日期',
    'donation_list.column_name': '姓名',
    'donation_list.column_amount': '金額',
    'donation_list.column_message': '留言',
    'donation_list.back_btn': '我要捐款',

    // Home
    'home.active_promotions': '進行中的推廣',
    'home.sort_by': '排序',
    'home.sort.newest': '最新',
    'home.sort.ending_soon': '即將結束',
    'home.sort.name': '名稱 (A-Z)',
    'home.sort.reward': '獎賞 % (高至低)',
    'home.sort.spend': '最低消費 (低至高)',
    'home.loading': '載入中...',
    'home.no_data': '暫無進行中的推廣。',
    'home.load_more': '載入更多',

    // Card
    'card.business_post': '商戶發布',
    'card.selected_member': '特選會員',
    'card.starts': '開始',
    'card.ends': '結束',
    'card.min_spend': '最低消費',
    'card.target_spend': '目標消費',
    'card.up_to': '高達',
    'card.reward': '獎賞',
    'card.online': '網店',
    'card.in_store': '門市',
    'card.last_modified': '最後修改：',
    'card.edit': '編輯',
    'card.favourite': '收藏',
    'card.join': '參加挑戰',
    'card.reg_req': '需登記',
    'card.log': '記錄',

    'cardholders.back_to_promo': '← 返回優惠詳情',
    'cardholders.title_with_card': '持有 {card} 的用戶',
    'cardholders.subtitle': '與這些用戶聯繫以享受專屬信用卡優惠。',
    'cardholders.loading': '載入用戶中...',
    'cardholders.no_data': '目前還沒有用戶登記持有此信用卡。',
    'cardholders.anonymous': '匿名用戶',
    'cardholders.view_profile': '查看個人檔案',

    // Log Transaction Modal
    'log_modal.title': '記錄交易',
    'log_modal.promo': '推廣活動',
    'log_modal.amount': '消費金額 ($)',
    'log_modal.date': '收據日期',
    'log_modal.receipt': '上傳收據 (選填)',
    'log_modal.submit': '提交交易',
    'log_modal.cancel': '取消',
    'log_modal.error_amount': '請輸入有效金額。',
    'log_modal.error_failed': '交易記錄失敗。',
    'log_modal.uploading': '處理中...',
    'log_modal.choose_file': '選擇檔案',

    'payment_modal.title': '選擇付款方式',
    'payment_modal.search_placeholder': '搜尋列表...',
    'payment_modal.loading': '載入中...',
    'payment_modal.error_loading': '無法載入付款方式。',
    'payment_modal.no_data': '找不到符合的付款方式。請在下方新增自訂方式。',
    'payment_modal.add_custom_label': '新增自訂付款方式：',
    'payment_modal.add_custom_placeholder': '例如：現金',
    'payment_modal.add_btn': '新增',
    'payment_modal.selected_count': '已選',
    'payment_modal.cancel_btn': '取消',
    'payment_modal.confirm_btn': '確認選擇',

    'promo_detail.title': '推廣詳情',
    'promo_detail.official_link': '查看官方優惠',
    'promo_detail.validity': '有效期與日期',
    'promo_detail.eligibility': '消費與資格',
    'promo_detail.banking': '銀行與信用卡',
    'promo_detail.locations': '可用地點',
    'promo_detail.rewards': '獎賞詳情',
    'promo_detail.targets': '挑戰目標',
    'promo_detail.eligible_days': '適用星期',
    'promo_detail.specific_dates': '特定日期',
    'promo_detail.online_shops': '網店',
    'promo_detail.physical_stores': '實體店',
    'promo_detail.places': '地區 / 商場',
    'promo_detail.reward_tiers': '階梯獎賞',
    'promo_detail.condition': '條件',
    'promo_detail.reward_val': '獎賞',
    'promo_detail.max_reward': '最高獎賞上限',
    'promo_detail.reg_detail': '登記詳情',
    'promo_detail.days.0': '星期日',
    'promo_detail.days.1': '星期一',
    'promo_detail.days.2': '星期二',
    'promo_detail.days.3': '星期三',
    'promo_detail.days.4': '星期四',
    'promo_detail.days.5': '星期五',
    'promo_detail.days.6': '星期六',
    'promo_detail.who_has_this_card': '誰有這張卡？',

    'promotions.today_special_title': "今日限定優惠",
    'promotions.no_specials': "今日暫無特定精選優惠。快來看看其他推廣活動吧！",
    'promotions.browse_all_promotions': "瀏覽所有促銷活動",
    'promotions.days_label': "適用日期 (星期)",
    'promotions.dates_label': "特定日期",

    'public_profile.back_to_cardholders': '← 返回持卡人列表 ({card})',
    'public_profile.loading': '載入檔案中...',
    'public_profile.anonymous': '匿名用戶',
    'public_profile.owned_cards': '持有的信用卡',
    'public_profile.no_cards': '該用戶尚未提供任何信用卡資料。',
    'public_profile.connect': '聯繫',
    'public_profile.email_address': '電郵地址',
    'public_profile.previously_unlocked': '✓ 已經解鎖',
    'public_profile.hidden_10_credits': '已隱藏 (需支付 10 積分)',
    'public_profile.not_provided': '用戶未提供',
    'public_profile.pay_10_reveal': '支付 10 積分以解鎖',
    'public_profile.phone_im': '電話及即時通訊',
    'public_profile.hidden_20_credits': '已隱藏 (需支付 20 積分)',
    'public_profile.pay_20_reveal': '支付 20 積分以解鎖',
    'public_profile.login_required': '請先登入以與其他用戶聯繫。',
    'public_profile.confirm_deduct': '這將從您的餘額中扣除 {cost} 積分。確定繼續？',
    'public_profile.cannot_unlock_self': '無法解鎖自己的檔案',

    'mealdeals.breakfast': '早餐',
    'mealdeals.lunch': '午餐',
    'mealdeals.afternoon_tea': '下午茶',
    'mealdeals.dinner': '晚餐',
    'mealdeals.midnight_snack': '宵夜',
    'mealdeals.title': '到 {meal} 時間了！',
    'mealdeals.view_all': '查看所有 {meal} 優惠',
    'mealdeals.up_to_percent': '低至 {reward} 折',
    'mealdeals.save_up_to': '節省高達 ${reward}',
    'mealdeals.no_deals': '目前沒有特定的{meal}優惠，請查看我們的其他優惠！',

    'partner.tagline': 'Snapperk 會員專享合作夥伴優惠',
    'partner.loading_collections': '正在載入最新系列...',
    'partner.no_offers': '目前沒有可用的 {brand} 優惠。',
    'partner.fetch_error': '載入合作夥伴推廣失敗。',
    'partner.loading_details': '正在載入詳情...',
    'partner.not_found': '找不到推廣活動。',
    'partner.use_code': '使用優惠碼：',
    'partner.shop_button': '前往官方網店購物',

    // --- NEW: Scan Page ---
    'scan.title': '新增推廣',
    'scan.subtitle': '請選擇輸入方式：',
    'scan.option1': '掃描圖片',
    'scan.option1_desc': '上傳優惠截圖或照片。',
    'scan.scanning': '掃描中...',
    'scan.upload_btn': '上傳圖片',
    'scan.option2': '掃描連結',
    'scan.option2_desc': '貼上推廣網頁連結。',
    'scan.extract_btn': '從連結提取',
    'scan.manual_btn': '手動輸入',
    'scan.or': '或是',

    'search.title': '搜尋推廣',
    'search.keyword': '關鍵字 (名稱/描述)',
    'search.bank': '銀行',
    'search.spending': '我的消費金額 ($)',
    'search.options': '選項',
    'search.online': '網店',
    'search.instore': '門市',
    'search.hide_filters': '隱藏篩選',
    'search.show_filters': '顯示篩選',
    'search.expired': '包括已過期',
    'search.upcoming': '包括即將開始',
    'search.categories': '類別',
    'search.select_categories': '選擇類別',
    'search.methods': '付款方式',
    'search.select_methods': '選擇付款方式',
    'search.stores': '商店',
    'search.select_stores': '選擇商店',
    'search.credit_cards': '信用卡',
    'search.select_cards': '選擇信用卡',
    'search.places': '地點',
    'search.select_places': '選擇地點',
    'search.selected': '已選',
    'search.reset': '重置',
    'search.btn': '搜尋',
    'search.searching': '搜尋中...',
    'search.enter_criteria': '請輸入搜尋條件。',
    'search.no_results': '找不到符合條件的推廣活動於',
    'search.load_more': '載入更多',
    'geo.location_aware': '位置感知',
    'geo.beta': '測試版',
    'geo.locating': '正在獲取位置...',
    'geo.location_ready': '位置已啟用',
    'geo.permission_denied': '位置權限被拒絕或無法使用',
    'geo.not_supported': '您的瀏覽器不支援地理位置功能',
    'geo.nearby': '附近',
    'geo.away': '距離',

    // --- NEW: Home Tabs ---
    'tabs.promotions': '進行中的推廣',
    'tabs.products': '產品優惠',

    'top_savers.title': '慳錢達人榜',
    'top_savers.subtitle': '最活躍的慳錢用戶於',
    'top_savers.rank': '排名',
    'top_savers.user': '用戶',
    'top_savers.savings': '總節省',
    'top_savers.view_transactions': '查看交易',
    'top_savers.period.day': '今日',
    'top_savers.period.week': '本週',
    'top_savers.period.month': '本月',
    'top_savers.period.year': '本年',
    'top_savers.period.all_time': '歷來',
    'top_savers.no_data': '沒有找到數據',

    // User Transactions Modal
    'transactions_modal.title': '最近交易',
    'transactions_modal.date': '日期',
    'transactions_modal.promotion': '推廣',
    'transactions_modal.amount': '消費金額',
    'transactions_modal.reward': '獎勵',
    'transactions_modal.no_data': '沒有找到交易記錄。',
    'transactions_modal.close': '關閉',
    'transactions_modal.receipt': '收據',
    'transactions_modal.status_verified': '已核實',
    'transactions_modal.status_rejected': '已拒絕',
    'transactions_modal.status_na': '不適用',
    'transactions_modal.status_pending': '已上傳收據 (待審核)',

    'banners.loading': '正在載入精選優惠...',
    'admin.banners.title': '橫幅廣告管理',
    'admin.banners.add': '新增橫幅',
    'admin.banners.edit': '編輯橫幅',

    'admin.store.title': '商店名稱維護',
    'admin.store.edit': '編輯商店',
    'admin.store.add': '新增商店',
    'admin.store.name': '商店名稱',
    'admin.store.country': '國家代碼',
    'admin.store.save': '儲存更改',
    'admin.store.add_btn': '新增商店',
    'admin.store.bulk': '大量上傳',
    'admin.store.csv_hint': 'CSV 格式：標題 `name`，然後每行一個商店名稱。',
    'admin.store.upload': '上傳 CSV',
    'admin.store.uploading': '上傳中...',
    'admin.store.existing': '現有商店',
    'admin.store.none': '找不到商店。',
    'admin.store.delete_confirm': '確定要刪除此商店嗎？',
    'admin.store.success_update': '商店更新成功。',
    'admin.store.success_add': '商店新增成功。',
    'admin.store.success_delete': '商店刪除成功。',
    'admin.store.success_upload': '上傳成功！新增 {inserted} 個，更新 {updated} 個。',
    'admin.store.locations': '商店地點',
    'admin.store.address': '地址',
    'admin.store.lat': '緯度',
    'admin.store.lng': '經度',
    'admin.store.add_loc_btn': '新增地點',
    'admin.store.no_locs': '尚未新增實體地點。',
    'admin.store.loc_list': '現有地點',
    'admin.store.populate_title': '從網頁或內容導入商店',
    'admin.store.input_mode_url': '網頁連結',
    'admin.store.input_mode_content': '直接貼上網頁內容 / 原始碼',
    'admin.store.english_url': '英文品牌網頁連結',
    'admin.store.non_english_url': '非英文品牌網頁連結 (例如中文)',
    'admin.store.english_content': '英文網頁內容 / HTML 原始碼',
    'admin.store.non_english_content': '非英文 (如中文) 網頁內容 / HTML 原始碼 (可選)',
    'admin.store.content_hint': '提示：若目標網站受 Cloudflare 403 反爬蟲保護 (如香港機場官網)，請在瀏覽器打開該網頁，全選 (Ctrl+A) 並複製內容或原始碼貼到此處。',
    'admin.store.predefined_alias': '預定義別名',
    'admin.store.predefined_categories': '預定義分類',
    'admin.store.extract_save': '導入並儲存商店',
    'admin.store.extracting': '正在導入...',
    'admin.store.search_placeholder': '🔍 搜尋商店名稱或別名...',
    'admin.store.success_populate': '成功導入商店！共提取 {extracted} 個，已插入 {inserted} 個，跳過 {skipped} 個',
    'admin.store.places': '所屬商場 / 地點',
    'admin.store.no_places': '尚未建立任何地點。請先在「地點維護」中新增。',
    'admin.store.tab_directory': '商店目錄與編輯',
    'admin.store.tab_csdi_matched': 'CSDI 地理數據導入 (已配對)',
    'admin.store.tab_csdi_unmatched': '未配對 CSDI 地標',
    'admin.store.tab_track_records': '操作記錄',
    'admin.store.aliases': '商店別名 (以逗號分隔)',
    'admin.store.aliases_placeholder': '例如：惠康, Wellcome Supermarket',
    'admin.store.enable_profile': '啟用商店專頁與品牌頁',
    'admin.store.profile_hint': '允許用戶瀏覽此商店的專屬品牌頁及各分店分佈。',
    'admin.store.activation_code': '激活碼 (實體店店長綁定)',
    'admin.store.generate_code': '生成激活碼',
    'admin.store.activation_code_hint': '將此代碼提供給實體門市商戶，以綁定其商務管理帳號。',
    'admin.store.lookup_gps': '查詢 GPS',
    'admin.store.searching_gps': '查詢中...',
    'admin.store.places_label': '商場/地點',
    'admin.store.locations_label': '分店地點',
    'admin.store.remove': '移除',
    'admin.store.showing_range': '顯示第 {start} 至 {end} 項，共 {total} 間商店',
    'admin.store.track_title': '操作歷史與審計記錄',
    'admin.store.track_hint': '記錄所有商店的新增、修改、導入及刪除歷史，支援一鍵還原至編輯器。',
    'admin.store.track_filter': '按商店過濾...',
    'admin.store.restore': '還原至編輯器',
    'admin.store.no_track_records': '沒有找到任何操作記錄。',
    'admin.store.auto_heal_title': '坐標自動修復 (BulkWrite)',
    'admin.store.auto_heal_desc': '掃描並修復地點 (Places)、CSDI 暫存記錄及商店中受損的 HK80 坐標。',
    'admin.store.auto_heal_btn': '執行批次修復',
    'admin.store.auto_heal_confirm': '確定要使用 BulkWrite 批次修復 MongoDB 中的受損坐標嗎？',
    'admin.store.auto_heal_running': '正在透過 BulkWrite 批次修復坐標...',
    'admin.store.auto_heal_healthy': '所有坐標正常，未檢測到受損坐標。',
    'admin.store.auto_heal_corrupted_found': '檢測到 {total} 筆受損坐標記錄 ({places} 個地點, {csdi} 筆 CSDI 記錄, {stores} 間商店)。',
    'admin.store.auto_heal_success': '成功透過批次寫入修復 {total} 筆坐標 ({places} 個地點, {csdi} 筆 CSDI, {stores} 間商店)。',
    'admin.store.auto_heal_refresh': '重新檢查',

    // CSDI Location Importer
    'admin.csdi.upload_title': '上傳 CSDI / 食環署批次 CSV 檔案',
    'admin.csdi.upload_hint': '上傳大量 CSV 檔案 (例如 9.5MB+，超過 50,000 筆記錄) 包含全港地理興趣點。系統會在背景非同步處理，運用純數學投影轉換並提供即時進度顯示。',
    'admin.csdi.choose_csv': '選擇 CSV 並配對',
    'admin.csdi.processing_bg': '背景處理中...',
    'admin.csdi.import_complete': '導入完成',
    'admin.csdi.processing_error': '處理出錯',
    'admin.csdi.uploading_csv': '正在上傳 CSV 檔案...',
    'admin.csdi.processing_records': '正在背景解析並比對 CSDI 記錄...',
    'admin.csdi.total_rows': '總筆數',
    'admin.csdi.processed': '已處理',
    'admin.csdi.matched_stores': '已配對商店',
    'admin.csdi.high_confidence': '高置信度',
    'admin.csdi.unmatched_pois': '未配對地標',
    'admin.csdi.pending_review': '待審核',
    'admin.csdi.high_confidence_safe': '高置信度 (安全)',
    'admin.csdi.needs_review': '需人工審核',
    'admin.csdi.already_applied': '已套用',
    'admin.csdi.discovered_malls_title': '自動發現缺失之商場',
    'admin.csdi.discovered_malls_hint': '從 CSDI 數據中識別出以下商場 (例如何文田廣場、德福廣場、富東廣場等)，但尚未於地點資料庫登記。審核並新增後，相關分店將自動以「高置信度」連結至該商場。',
    'admin.csdi.rescan_malls': '重新掃描商場',
    'admin.csdi.add_selected_malls': '將選中商場加入地點並重新配對',
    'admin.csdi.adding_malls': '正在新增並重新配對...',
    'admin.csdi.mall_name_en_zh': '商場名稱 (中英文)',
    'admin.csdi.short_tag': '短標籤',
    'admin.csdi.district_address': '所屬分區與共識地址',
    'admin.csdi.centroid_gps': '中心點 GPS',
    'admin.csdi.detected_stores': '關聯商店數',
    'admin.csdi.action': '操作',
    'admin.csdi.add_and_link': '加入並連結',
    'admin.csdi.no_gps': '無 GPS',
    'admin.csdi.scanning': '掃描中...',
    'admin.csdi.scan_prompt': 'CSDI 數據中有未登記的商場？立即掃描以發現商場 (例如：何文田廣場、德福廣場) 並加到地點資料庫。',
    'admin.csdi.scan_btn': '掃描缺失商場',
    'admin.csdi.all_stores': '所有商店',
    'admin.csdi.status_pending': '待審核',
    'admin.csdi.status_applied': '已套用',
    'admin.csdi.status_rejected': '已拒絕',
    'admin.csdi.all_statuses': '所有狀態',
    'admin.csdi.all_confidences': '所有置信度',
    'admin.csdi.high_confidence_only': '僅高置信度',
    'admin.csdi.medium_confidence': '中置信度',
    'admin.csdi.low_confidence': '低置信度',
    'admin.csdi.search_address_store': '搜尋地址 / 商店...',
    'admin.csdi.quick_apply': '快速套用所有高置信度',
    'admin.csdi.apply_selected': '套用選取項目',
    'admin.csdi.reject_selected': '拒絕選取項目',
    'admin.csdi.th_store': '商店品牌 (CSDI 名稱)',
    'admin.csdi.th_address': '檢測地址與分區',
    'admin.csdi.th_gps': '地點 GPS',
    'admin.csdi.th_action_override': '建議操作與商場變更',
    'admin.csdi.th_confidence_reason': '置信度與判定理由',
    'admin.csdi.th_actions': '操作',
    'admin.csdi.opt_street': '地舖門市',
    'admin.csdi.opt_mall': '商場內門市：',
    'admin.csdi.btn_apply': '套用',
    'admin.csdi.btn_reject': '拒絕',
    'admin.csdi.no_staged_records': '沒有符合篩選條件的暫存記錄。',
    'admin.csdi.unmatched_title': '未配對之 CSDI 地標業務',
    'admin.csdi.unmatched_hint': '以下地標記錄無法自動配對現有商店品牌。您可以審核資料、連結所屬商場，並一鍵建立為全新商店品牌。',
    'admin.csdi.unmatched_search_placeholder': '搜尋未配對地標 / 地址 / 分區...',
    'admin.csdi.btn_create_store': '建立新商店',
    'admin.csdi.th_poi_name': '商戶 / 地標名稱',
    'admin.csdi.th_poi_address': '檢測地址',
    'admin.csdi.th_poi_gps': 'GPS 座標',
    'admin.csdi.th_nearest_mall': '附近檢測到之商場',
    'admin.csdi.modal_create_store_title': '從 CSDI 記錄建立新商店',
    'admin.csdi.modal_create_store_hint': '此操作將在商店目錄中註冊新品牌，設定初始分店地址與經緯度，並連結商場關係。',
    'admin.csdi.initial_address': '初始分店地址',
    'admin.csdi.associated_mall': '所屬購物商場 (地點)',
    'admin.csdi.select_mall_opt': '選擇所屬商場 (可選)',
    'admin.csdi.street_shop_none': '獨立地舖 (無商場)',
    'admin.csdi.btn_create_link': '建立商店並連結地點',
    'admin.csdi.creating': '建立中...',
    'admin.place.title': '地點 / 商場維護',
    'admin.place.edit': '編輯地點',
    'admin.place.add': '新增地點',
    'admin.place.name': '地點 / 商場名稱 (主要 / 顯示)',
    'admin.place.name_en': '英文名稱 (例如 Times Square)',
    'admin.place.name_zh': '繁體中文名稱 (例如 時代廣場)',
    'admin.place.name_ja': '日文名稱 (例如 タイムズスクエア)',
    'admin.place.short_tag': '短標籤 / Hashtag (例如 TimesSquare)',
    'admin.place.country': '國家 / 地區代碼',
    'admin.place.address': '地址',
    'admin.place.lookup_btn': '查詢經緯度',
    'admin.place.csdi_btn': 'CSDI 地理搜尋',
    'admin.place.csdi_searching': '正在搜尋 CSDI...',
    'admin.place.csdi_found': '已從 CSDI 自動填入：{name}',
    'admin.place.csdi_none': '在 CSDI 找不到相符的地點。',
    'admin.place.lat': '緯度',
    'admin.place.lng': '經度',
    'admin.place.coordinates': 'GPS 經緯度',
    'admin.place.no_coords': '未設定 GPS 經緯度',
    'admin.place.save': '儲存更改',
    'admin.place.add_btn': '新增地點',
    'admin.place.cancel': '取消',
    'admin.place.existing': '現有地點與商場',
    'admin.place.none': '找不到地點。',
    'admin.place.delete_confirm': '確定要刪除此地點嗎？',
    'admin.place.success_add': '地點新增成功。',
    'admin.place.success_update': '地點更新成功。',
    'admin.place.success_delete': '地點刪除成功。',
    'admin.place.bulk_upload': '批次 CSV 上傳',
    'admin.place.bulk_upload_hint': '支援的欄位：name, nameZh, countryCode, shortTag, address, lat, lng (或官方 CSDI CSV：NAME_EN, NAME_ZH, EASTING, NORTHING)。',
    'admin.place.download_template': '下載範例 CSV',
    'admin.place.upload_btn': '上傳地點 CSV',
    'admin.place.uploading': '正在上傳...',
    'admin.place.upload_success': '批次上傳成功！處理：{processed}，新增：{inserted}，更新：{modified}。',
    'admin.place.search_placeholder': '🔍 搜尋地點或商場名稱、標籤或地址...',
    'admin.place.showing_range': '顯示第 {start} 至 {end} 項，共 {total} 個地點',
    'card.code': '優惠碼',
    'card.max_target_transactions': '最大目標交易次數',
    'card.max_target_spend': '最大目標消費額',
    'card.your_reward': '您的獎賞',


    'admin.ai_models': 'AI 模型管理',
    'admin.ai_models.title': 'AI 模型管理',
    'admin.ai_models.discover_btn': '自動檢測 Gemini 模型',
    'admin.ai_models.discover_deepseek_btn': '自動檢測 DeepSeek 模型',
    'admin.ai_models.discovering': '正在檢測...',
    'admin.ai_models.discovering_deepseek': '正在檢測 DeepSeek...',
    'admin.ai_models.models_title': '可用 AI 模型',
    'admin.ai_models.failed_title': '近期失敗模型記錄 (15分鐘冷卻)',
    'admin.ai_models.table_name': '模型 ID',
    'admin.ai_models.table_provider': '供應商',
    'admin.ai_models.table_display': '顯示名稱',
    'admin.ai_models.table_status': '狀態',
    'admin.ai_models.table_actions': '操作',
    'admin.ai_models.table_failed_at': '失敗時間',
    'admin.ai_models.table_reason': '失敗原因',
    'admin.ai_models.table_priority': '優先順序',
    'admin.ai_models.status_enabled': '已啟用',
    'admin.ai_models.status_disabled': '已停用',
    'admin.ai_models.btn_enable': '啟用',
    'admin.ai_models.btn_disable': '停用',
    'admin.ai_models.btn_clear_fail': '清除失敗記錄',
    'admin.ai_models.no_failed_models': '目前沒有失敗模型記錄。',
    'admin.ai_models.no_models': '找不到模型。請點擊上方自動檢測。',

    'admin.ai_tasks': 'AI 任務配置',
    'admin.ai_tasks.title': 'AI 任務配置',
    'admin.ai_tasks.subtitle': '管理各項業務工作負載的 AI 模型優先管線與超時時間。可選模型動態來源於「AI 模型管理」中已啟用的模型。',
    'admin.ai_tasks.tab_models': 'AI 模型註冊庫',
    'admin.ai_tasks.tab_tasks': '任務配置',
    'admin.ai_tasks.select_task': '選擇 AI 任務',
    'admin.ai_tasks.task_name': '任務名稱',
    'admin.ai_tasks.task_desc': '任務描述',
    'admin.ai_tasks.timeout': '超時時間 (秒)',
    'admin.ai_tasks.model_pipeline': '模型優先順序管線',
    'admin.ai_tasks.pipeline_hint': '請求將按照自上而下的順序嘗試模型。若某模型失敗或超時，系統將自動依序嘗試下一個模型。',
    'admin.ai_tasks.add_model': '新增模型至管線',
    'admin.ai_tasks.select_model': '-- 選擇已啟用的模型 --',
    'admin.ai_tasks.no_enabled_models': '沒有可新增的已啟用模型。',
    'admin.ai_tasks.move_up': '上移',
    'admin.ai_tasks.move_down': '下移',
    'admin.ai_tasks.remove': '移除',
    'admin.ai_tasks.save': '儲存管線配置',
    'admin.ai_tasks.saving': '正在儲存...',
    'admin.ai_tasks.save_success': '任務配置已成功更新。',
    'admin.ai_tasks.save_error': '儲存任務配置失敗。',
    'admin.ai_tasks.task_recommendation': '優惠推薦',
    'admin.ai_tasks.task_image_scanning': '圖片掃描與 OCR',
    'admin.ai_tasks.empty_pipeline': '管線中尚無模型。請至少新增一個已啟用的模型。',
    'admin.ai_tasks.fast_multimodal_hint': '建議將超高速多模態模型（如 gemini-2.5-flash）置於管線最頂層，以獲得極速 OCR 識別效果。',
    'admin.ai_tasks.seed_fast_models': '重設為推薦高速模型',
    'admin.ai_tasks.seed_fast_models_confirm': '確定要將圖片掃描管線重設為推薦的高速多模態模型嗎？',

    // Admin System Settings
    'admin.cron_jobs': '排程任務與循環優惠',
    'admin.system_settings': '系統設定',
    'admin.system_settings.title': '內容審核與防垃圾推廣設定',
    'admin.system_settings.subtitle': '配置圖片質量檢測、垃圾訊息識別以及重複違規封禁的門檻值。',
    'admin.system_settings.blur_threshold': '圖片模糊度清晰門檻（拉普拉斯方差）',
    'admin.system_settings.blur_hint': '低於此方差門檻的圖片將被判定為模糊（預設：90.0）。',
    'admin.system_settings.blank_threshold': '空白圖片亮度方差門檻',
    'admin.system_settings.blank_hint': '亮度標準差低於此門檻的圖片將被判定為空白或純色（預設：8.0）。',
    'admin.system_settings.spam_ban_threshold': '觸發24小時封禁的違規次數上限',
    'admin.system_settings.spam_hint': '用戶被駁回的違規優惠累積達此上限後，將被自動暫停發佈24小時（預設：3）。',
    'admin.system_settings.ban_duration': '封禁時長（小時）',
    'admin.system_settings.ban_duration_hint': '達到違規次數上限時的暫停發佈時長（預設：24）。',
    'admin.system_settings.radius_title': '即時位置與「附近」搜尋半徑 (公里)',
    'admin.system_settings.radius_hint': '適用於探索頁「附近」推廣優惠、即時位置篩選以及周邊商場標籤發現的預設搜尋半徑（預設：2.0 公里）。',
    'admin.system_settings.geofence_limit': '地理圍欄驗證距離上限（米）',
    'admin.system_settings.geofence_hint': '驗證用戶發佈實體店優惠時，用戶 GPS 與店舖 GPS 之間的最大允許距離（預設：200米）。',
    'admin.system_settings.duplicate_hamming_threshold': '重複圖片漢明距離門檻（Hamming Distance）',
    'admin.system_settings.duplicate_hamming_hint': '判定兩張圖片為近似重複的最大感知雜湊漢明距離（0–16）。數值越低越能減少誤判（預設：3）。',
    'admin.system_settings.trusted_template_providers': '受信任模板平台名單（以逗號分隔）',
    'admin.system_settings.trusted_template_providers_hint': '畫面截圖佈局高度一致的電子錢包或支付平台（如 PayMe、AlipayHK、WeChat Pay）。若優惠標題或推廣日期不同，系統將豁免重複圖片阻擋。',
    'admin.system_settings.save': '儲存設定',
    'admin.system_settings.saving': '正在儲存...',
    'admin.system_settings.save_success': '系統審核設定已成功儲存。',
    'admin.system_settings.save_error': '儲存系統設定失敗。',

    // Admin Users Ban Management
    'admin.users.ban_status': '發佈封禁狀態',
    'admin.users.banned_until': '封禁至',
    'admin.users.unban': '解除封禁',
    'admin.users.unban_confirm': '確定要解除此用戶的發佈優惠封禁嗎？',
    'admin.users.unbanned_success': '用戶發佈封禁已成功解除。',
    'admin.users.clean_status': '正常',
    'admin.users.strikes': '違規累積次數',
    'admin.users.ban_history': '封禁記錄',
    'admin.users.no_ban_history': '暫無封禁記錄。',

    // Promotion Lifecycle: Ban & Delete
    'promo.ban_btn': '封禁優惠',
    'promo.ban_confirm': '確定要封禁此優惠嗎？封禁後將從公開搜尋中隱藏。',
    'promo.ban_reason_prompt': '請輸入封禁原因（可選）：',
    'promo.banned_success': '優惠已被成功封禁。',
    'promo.delete_btn': '刪除優惠',
    'promo.delete_confirm': '確定要刪除此優惠嗎？此操作無法撤銷。',
    'promo.delete_success': '優惠已成功刪除。',
    'promo.error.cannot_delete_has_challenges': '無法刪除優惠：已有用戶參與了與此優惠相關的挑戰或成就。',
    'promo.error.banned': '由於多次發佈不合規或無效內容，您的帳號已被暫停發佈優惠至 {date}。',
    'promo.error.dummy_text': '請提供有效的優惠標題及詳情描述。',
    'promo.error.blank_image': '所選圖片似乎為空白或純色，請上傳清晰的優惠海報。',
    'promo.error.blurry_image': '圖片過於模糊無法辨識，請上傳清晰照片。',
    'promo.error.sensitive_info': '不可發佈含有敏感資訊（如信用卡資料或身份證件）的優惠。',

    'common.prev': '上一頁',
    'common.next': '下一頁',
    'common.page': '第',
    'common.of': '頁，共',
    'common.page_of': '第 {page} 頁，共 {total} 頁',
    'common.cancel': '取消',
    'common.edit': '編輯',
    'common.delete': '刪除',
    'common.loading': '載入中...',

    // Admin Banned Promotions
    'admin.promotions': '推廣數據與 SEO 指南',
    'admin.banned_promotions': '被封禁推廣',
    'admin.banned_promos.title': '被封禁推廣',
    'admin.banned_promos.subtitle': '檢視及管理已被封禁或拒絕的推廣優惠。',
    'admin.banned_promos.promo_name': '推廣名稱',
    'admin.banned_promos.author': '發布者',
    'admin.banned_promos.created_at': '建立日期及時間',
    'admin.banned_promos.verification_status': '驗證狀態',
    'admin.banned_promos.rejection_reason': '拒絕原因',
    'admin.banned_promos.actions': '操作',
    'admin.banned_promos.unban_btn': '解除封禁',
    'admin.banned_promos.unbanning': '正在解除封禁...',
    'admin.banned_promos.unban_confirm': '您確定要解除對此推廣的封禁嗎？解除後將恢復為有效及已驗證狀態。',
    'admin.banned_promos.unban_success': '已成功解除推廣封禁。',
    'admin.banned_promos.unban_failed': '解除推廣封禁失敗。',
    'admin.banned_promos.no_data': '沒有找到被封禁的推廣。',
    'admin.banned_promos.unknown_author': '未知用戶',

    // Tax Calculator
    'tax.fab_title': '繳稅優惠',
    'tax.fab_subtitle': '繳稅回贈計算機',
    'tax.fab_dismiss': '本次關閉',
    'tax.banner_title': '繳稅回贈計算機',
    'tax.banner_subtitle': '比較香港各銀行信用卡及支付平台繳稅優惠，賺取最高回贈',
    'tax.section1_title': '1. 回贈偏好',
    'tax.pref_cash': '現金回贈 ($)',
    'tax.pref_cash_desc': '結單回贈及現金券',
    'tax.pref_miles': '飛行里數 (Miles)',
    'tax.pref_miles_desc': 'Asia Miles 及常客飛行積分',
    'tax.section2_title': '2. 稅款總額',
    'tax.section3_title': '3. 分期繳交 (可選)',
    'tax.pay_installments': '分期繳交稅款',
    'tax.installment_schedule_subtitle': '分期金額及繳費日程：',
    'tax.split_2': '分 2 期',
    'tax.split_3': '分 3 期',
    'tax.add_installment': '+ 新增',
    'tax.installment_sum_matched': '✓ 分期總額與稅款相符：HK$ {sum}',
    'tax.installment_diff': '⚠️ 差額：HK$ {diff}（{reason}）',
    'tax.exceeds_tax': '超出稅款總額',
    'tax.remaining_unallocated': '尚餘未分配金額',
    'tax.section4_title': '4. 繳稅推廣優惠',
    'tax.cross_promotion': '跨推廣組合最佳化',
    'tax.promos_selected': '已選 {selected}/{total} 項推廣',
    'tax.select_all': '全選',
    'tax.clear': '清除',
    'tax.same_bank_warning': '每位客戶在同一銀行／平台可能只可享用 1 項繳稅推廣優惠 ({bank})。',
    'tax.promo_expires_warning': '{brand} 在您的其中一個分期繳費日前已過期。',
    'tax.loading_promos': '正在載入繳稅推廣優惠...',
    'tax.empty_promos_msg': '我們正努力載入繳稅推廣優惠，您也可以協助我們新增',
    'tax.add_promo_btn': '+ 新增推廣優惠',
    'tax.air_miles_promo': '飛行里數推廣',
    'tax.cash_rebate_promo': '現金回贈推廣',
    'tax.calculate_btn': '開始計算回贈',
    'tax.share_card.tagline': '繳稅回贈計算機',
    'tax.share_card.total_tax': '稅款總額',
    'tax.share_card.optimized_rebate': '最佳組合回贈',
    'tax.share_card.best_rebate': '最高回贈',
    'tax.share_card.installment_schedule': '分期日程',
    'tax.share_card.allocation_strategy': '簽賬分配策略',
    'tax.share_card.installment_item': '第 {index} 期 (HK$ {amount})',
    'tax.share_card.due_date': '到期日: {date}',
    'tax.share_card.watermark': '由 SnapPerk 計算 | 香港精明著數引擎',
    'tax.share_card.copied': '✓ 已複製摘要',
    'tax.share_card.share': '📤 分享摘要',
    'tax.share_card.summary_title': '🌟 SNAP PERK 繳稅回贈摘要',
    'tax.share_card.calculated_on': '📅 計算日期: {date}',
    'tax.share_card.total_tax_line': '💰 稅款總額: HK${tax}',
    'tax.share_card.max_rebate_line': '🎯 最高回贈: {rebate}',
    'tax.share_card.strategy_header': '📋 策略:',
    'tax.share_card.installment_header': '📋 分期明細:',
    'tax.share_card.installment_row': '• 第 {index} 期: HK${amount}{due} => 回贈: {rebate}',
    'tax.share_card.cta': '🚀 在 SNAP PERK 計算您的信用卡繳稅回贈: https://www.snapperk.app/tax-calculator',
    'tax.tiered_rebate': '階梯式回贈',
    'tax.min_spend': '最低簽賬',
    'tax.fixed_rebate': '固定回贈',
    'tax.rebate': '回贈',
    'tax.capped_at': '上限為',
    'tax.tier_reached': '已達階梯',
    'tax.no_additional_rebate': '無額外回贈 (未達門檻)',
    'tax.below_min_spend': '未達最低簽賬額 ({amount})',
    'tax.hit_max_cap': '已達最高上限 {amount}',
    'tax.fixed_reward_reached': '已達固定獎賞 ({amount})',
    'tax.promo_expired_due_date': '推廣期在繳稅到期日前已結束',
    'tax.miles_2k_reward': '2,000 里數 (需滿 HK$3,000 零售簽賬)',
    'tax.miles_4k_reward': '4,000 里數 (需滿 HK$20,000 零售簽賬)',
    'tax.below_min_miles_spend': '未達最低里數簽賬門檻 (HK$3,000)',
    'tax.miles_bea_desc': '2,000 里數 (零售簽賬滿 HK$3,000) 或 4,000 里數 (零售簽賬滿 HK$20,000)',
    'tax.spend_x_for_y_rebate': '簽賬滿 {spend} 享 {rebate} 回贈',

    // Open Account Calculator
    'open_account.fab_title': '開戶迎新',
    'open_account.fab_subtitle': '拆單計算機',
    'open_account.fab_dismiss': '暫時關閉',
    'open_account.banner_title': '迎新開戶賞計算機',
    'open_account.banner_subtitle': '將全新資金拆分存入不同銀行迎新開戶優惠，賺取最高回贈',
    'open_account.section1_title': '1. 回贈偏好',
    'open_account.pref_cash': '現金回贈 ($)',
    'open_account.pref_cash_desc': '現金回贈、簽賬回贈及禮券',
    'open_account.pref_miles': '飛行里數 (里)',
    'open_account.pref_miles_desc': '亞洲萬里通及飛行積分',
    'open_account.section2_title': '2. 全新資金金額',
    'open_account.new_money_label': '全新資金總金額 (HK$)',
    'open_account.section3_title': '3. 選擇開戶迎新優惠',
    'open_account.cross_promotion': '跨行開戶拆單優化',
    'open_account.cross_promotion_desc': '拆分資金至不同開戶優惠以獲取最高合併迎新獎賞',
    'open_account.promos_selected': '已選 {selected}/{total} 項開戶優惠',
    'open_account.select_all': '全選',
    'open_account.clear': '清除',
    'open_account.same_bank_warning': '每位客戶於同一銀行通常只可享有一項開戶迎新優惠（{bank}）。',
    'open_account.loading_promos': '正在載入開戶優惠...',
    'open_account.empty_promos_msg': '我們正努力新增迎新開戶相關優惠',
    'open_account.add_promo_btn': '+ 新增開戶優惠',
    'open_account.calculate_btn': '計算最佳開戶組合',
    'open_account.share_card.tagline': '全新資金開戶回贈計算機',
    'open_account.share_card.total_money': '全新資金總額',
    'open_account.share_card.allocated': '已分配存入金額',
    'open_account.share_card.unallocated': '尚餘未分配資金',
    'open_account.share_card.optimized_reward': '最佳開戶回贈',
    'open_account.share_card.best_reward': '最高回贈',
    'open_account.share_card.allocation_strategy': '最佳拆單分配策略',
    'open_account.share_card.single_comparison': '單一開戶對比',
    'open_account.share_card.single_comparison_desc': '若將全新資金全部存入單一銀行戶口',
    'open_account.share_card.gain_vs_single': '比最高單一開戶多賺 +{gain} (+{percent}%)',
    'open_account.share_card.deposit_req': '存入 HK${amount}',
    'open_account.share_card.watermark': "Calculated with SnapPerk | Hong Kong's Smartest Promotion Engine",
    'open_account.share_card.copied': '✓ 已複製摘要',
    'open_account.share_card.share': '📤 分享開戶摘要',
    'open_account.share_card.summary_title': '🌟 SNAP PERK 迎新開戶獎賞概要',
    'open_account.share_card.calculated_on': '📅 計算時間: {date}',
    'open_account.share_card.total_line': '💰 全新資金總額: HK${money}',
    'open_account.share_card.allocated_line': '🏦 已分配存款: HK${amount}',
    'open_account.share_card.unallocated_line': '💵 尚餘閒置資金: HK${amount}',
    'open_account.share_card.max_reward_line': '🎯 最高迎新回贈: {reward}',
    'open_account.share_card.strategy_header': '📋 最佳拆單分配策略:',
    'open_account.share_card.account_row': '• {bank}（{name}）: 存入 HK${amount} => 回贈: {reward}',
    'open_account.share_card.cta': '🚀 立即在 SNAP PERK 計算全新資金拆單最佳開戶組合: https://www.snapperk.app/open-account-calculator',
    'open_account.deposit_x_for_y': '存入 {deposit} 享 {reward} 回贈',

    // Handy Tools
    'tools.title': '專項實用工具',
    'tools.subtitle': '專用優惠計算及拆單工具，助您賺盡各項獎賞',
    'tools.coming_soon': '即將推出',
    'tools.open_tool': '進入計算機',
    'tools.tax_title': '繳稅回贈計算機',
    'tools.tax_desc': '比較香港各銀行信用卡及支付平台繳稅優惠，賺取最高回贈',
    'tools.open_account_title': '迎新開戶賞計算機',
    'tools.open_account_desc': '將全新資金拆分存入不同銀行迎新開戶優惠，賺取最高回贈',
    'tools.time_deposit_title': '定期存款利率計算機',
    'tools.time_deposit_desc': '比較及計算全港最高定期存款利息收益',
    'tools.spending_split_title': '拆單簽賬目標計算機',
    'tools.spending_split_desc': '將大額簽賬拆分至多張信用卡以達成最高迎新或階段目標',
    'tools.air_miles_title': '里數現金價值換算器',
    'tools.air_miles_desc': '即時評估 Asia Miles 等飛行里數與現金回贈之價值比較',
    'tools.stay_tuned': '此專項工具正在開發中，敬請期待！'
  },
  ja: {
    // Nav
    'nav.home': 'ホーム',
    'nav.search': '検索',
    'nav.search_products': '商品検索',
    'nav.add': 'プロモ追加',
    'nav.scan': 'スキャン',
    'nav.scan_product': '商品スキャン',
    'nav.contact': 'お問い合わせ',
    'nav.my_space': 'マイページ',
    'nav.my_dashboard': 'ダッシュボード',
    'nav.my_promotions': '私のプロモ',
    'nav.my_inbox': '受信トレイ',
    'nav.my_favourites': 'お気に入り',
    'nav.my_achievements': '達成状況',
    'nav.memberships': '会員資格',
    'nav.business_plans': 'ビジネスプラン',
    'nav.admin': '管理',
    'nav.business_tools': 'ビジネスツール',
    'nav.business_profile': 'ビジネス情報',
    'nav.premise_mgmt': '店舗管理',
    'nav.claim_premise': '店舗申請',
    'nav.add_simple_promo': '簡易プロモ追加',
    'nav.target_audience': 'ターゲット層',
    'nav.total_saved': '節約総額',
    'nav.welcome': 'ようこそ',
    'nav.logout': 'ログアウト',
    'nav.login': '登録 / ログイン',
    'nav.market': 'マーケット',
    'nav.donate': '寄付する',
    'nav.tax_calculator': '税金還元',
    'nav.handy_tools': '便利ツール',
    'nav.open_account_calculator': '口座開設',
    'nav.it': 'i.t',
    'nav.card_holders': 'Card Holders',
    'nav.today_special': "今日のスペシャル",
    'nav.dev_portal': '開発者ポータル',
    'nav.erd': 'ER図',
    'erd.title': '開発者向けER図ビジュアライザ',
    'erd.subtitle': 'バックエンドの handlers.go 構造体から動的に生成',
    'erd.btn_test_render': '🧪 簡易テスト描画',
    'erd.btn_refresh': '🔄 更新',
    'erd.btn_view_code': '💻 コード表示',
    'erd.btn_view_diagram': '👁️ 図を表示',
    'erd.btn_copy_code': '📋 コードをコピー',
    'erd.filter_entities': 'エンティティのフィルター',
    'erd.select_all': 'すべて選択',
    'erd.clear_all': 'クリア',
    'erd.loading': 'handlers.go の構造体を解析してER図を作成中...',
    'erd.copied_msg': 'Mermaid構文がクリップボードにコピーされました！',

    // Consent
    'nav.consent_pre': '続行することで、',
    'nav.terms': '利用規約',
    'nav.consent_mid': 'に同意し、',
    'nav.privacy': 'プライバシーポリシー',
    'nav.consent_post': 'を確認したことになります。',
    'nav.bill_analyzer': '請求書アナライザー',

    // Admin
    'admin.subscriptions': '全サブスク',
    'admin.users': 'ユーザー管理',
    'admin.messages': '顧客メッセージ',
    'admin.messages.review_title': 'メッセージの確認',
    'admin.messages.from': '送信元',
    'admin.messages.user_profile': 'ユーザープロファイル',
    'admin.messages.member': '会員',
    'admin.messages.phone': '電話',
    'admin.messages.date': '日付',
    'admin.messages.message_label': 'メッセージ',
    'admin.messages.admin_remarks': '管理者メモ',
    'admin.messages.internal_notes_placeholder': '内部メモ...',
    'admin.messages.cancel': 'キャンセル',
    'admin.messages.close_ticket': 'チケットを閉じる',
    'admin.messages.reopen_ticket': 'チケットを再開',
    'admin.messages.title': '顧客メッセージ',
    'admin.messages.open': 'オープン',
    'admin.messages.closed': 'クローズ',
    'admin.messages.loading': '読み込み中...',
    'admin.messages.no_open_messages': 'オープンなメッセージはありません。',
    'admin.messages.no_closed_messages': 'クローズされたメッセージはありません。',
    'admin.messages.update_failed': '更新に失敗しました',
    'admin.reports': '報告された問題',
    'admin.logs.title': 'API システムログ',
    'admin.logs.subtitle': '請求書アップロードなどのバックエンド処理のトラブルシューティング。',
    'admin.logs.loading': 'ログを読み込み中...',
    'admin.logs.no_data': 'ログが見つかりません。',
    'admin.logs.time': '時間',
    'admin.logs.endpoint': 'エンドポイント',
    'admin.logs.status': 'ステータス',
    'admin.logs.ip_address': 'IP アドレス',
    'admin.logs.user_id': 'ユーザー ID',
    'admin.logs.message': 'メッセージ',
    'admin.logs.action': 'アクション',
    'admin.logs.details': '詳細',
    'admin.logs.prev': '前へ',
    'admin.logs.next': '次へ',
    'admin.logs.page_of': 'ページ {page} / {totalPages}',
    'admin.logs.details_title': 'ログ詳細',
    'admin.logs.status_label': 'ステータス:',
    'admin.logs.time_label': '時間:',
    'admin.logs.endpoint_label': 'エンドポイント:',
    'admin.logs.ip_label': 'IP:',
    'admin.logs.user_id_label': 'ユーザー ID:',
    'admin.logs.message_label': 'メッセージ:',
    'admin.logs.payload_label': 'ペイロード / 生レスポンス:',
    'admin.logs.no_payload': 'ペイロードは記録されていません。',
    'admin.logs.filters.title': 'フィルター',
    'admin.logs.filters.start_date': '開始日時',
    'admin.logs.filters.end_date': '終了日時',
    'admin.logs.filters.endpoint': 'エンドポイント URL',
    'admin.logs.filters.status': 'ステータスコード',
    'admin.logs.filters.ip': 'IP アドレス',
    'admin.logs.filters.user_id': 'ユーザー ID',
    'admin.logs.filters.ai_version': 'AI モデルバージョン',
    'admin.logs.filters.btn_filter': 'フィルターを適用',
    'admin.logs.filters.btn_clear': 'クリア',
    'admin.banks': '銀行管理',
    'admin.banks.title': '銀行マスタリスト',
    'admin.banks.add_bank': '銀行を追加',
    'admin.banks.edit_bank': '銀行を編集',
    'admin.banks.add_new_bank': '新規銀行を追加',
    'admin.banks.bank_name_en': '標準名（英語）',
    'admin.banks.bank_name_zh': '繁体字中国語',
    'admin.banks.bank_name_ja': '日本語',
    'admin.banks.bank_key': '識別キー (Key)',
    'admin.banks.country': '国/地域コード',
    'admin.banks.save_changes': '変更を保存',
    'admin.banks.cancel': 'キャンセル',
    'admin.banks.bulk_upload': '一括アップロード',
    'admin.banks.bulk_upload_hint': 'CSV形式: name,country,nameZh,nameJa,key',
    'admin.banks.upload_csv': 'CSVアップロード',
    'admin.banks.uploading': 'アップロード中...',
    'admin.banks.existing_banks': '登録済み銀行 ({count})',
    'admin.banks.delete_confirm': 'この銀行を削除しますか？',
    'admin.banks.save_success': '銀行が正常に追加されました。',
    'admin.banks.update_success': '銀行が正常に更新されました。',
    'admin.banks.delete_success': '銀行が正常に削除されました。',
    'admin.banks.upload_success': '一括アップロード成功！{count}件追加されました。',
    'admin.banks.no_banks': '銀行が見つかりません。',
    'admin.banks.loading': '読み込み中...',
    'admin.banks.actions': '操作',
    'admin.banks.edit': '編集',
    'admin.banks.delete': '削除',
    'admin.credit_cards': 'カード管理',
    'admin.credit_cards.title': 'クレジットカードマスタリスト',
    'admin.credit_cards.short_tag': '略称タグ',
    'admin.credit_cards.aliases': '別名 (カンマ区切り)',
    'admin.credit_cards.aliases_label': '別名',
    'admin.credit_cards.bank_name': '銀行名',
    'admin.credit_cards.card_name': 'カード名',
    'admin.credit_cards.issuer': 'カード会社',
    'admin.credit_cards.country': '国/地域',
    'admin.credit_cards.active': '有効',
    'admin.credit_cards.actions': '操作',
    'admin.credit_cards.add_card': 'カードを追加',
    'admin.credit_cards.option_ai': 'オプション 1: ウェブサイトからインポート (AI)',
    'admin.credit_cards.option_csv': 'オプション 2: CSV一括アップロード',
    'admin.credit_cards.option_manual': 'オプション 3: 手動入力',
    'admin.credit_cards.url_placeholder': 'ここに銀行のクレジットカードページのURLを貼り付けます...',
    'admin.credit_cards.extract_btn': 'カードを抽出',
    'admin.credit_cards.extracting_btn': 'スキャン中...',
    'admin.credit_cards.upload_csv_btn': 'CSVアップロード',
    'admin.credit_cards.save_success': 'カードが正常に追加されました。',
    'admin.credit_cards.update_success': 'カードが正常に更新されました。',
    'admin.credit_cards.delete_confirm': 'このカードを削除しますか？',
    'admin.credit_cards.staging_title': '確認して保存 ({count})',
    'admin.credit_cards.all_cards': 'すべてのクレジットカード',
    'admin.credit_cards.loading': 'リストを読み込み中...',
    'admin.payment_methods': '決済方法管理',
    'admin.stores': '店舗管理',
    'admin.places': 'エリア管理',
    'admin.questions': '質問管理',
    'admin.categories': 'カテゴリ管理',
    'admin.category_name_en': '標準名（英語）',
    'admin.category_name_zh': '繁体字中国語',
    'admin.category_name_ja': '日本語',
    'admin.category_key': '識別キー',
    'admin.category_normalize_btn': 'カテゴリを分割・標準化',
    'admin.category_normalize_confirm': 'これにより、混合カテゴリ名が個別の言語フィールドに分割され、プロモーションが標準化されます。続行しますか？',
    'admin.category_normalized_success': 'カテゴリとプロモーションが正常に標準化されました！',
    'admin.invite': '招待作成',
    'admin.web_scraper': "ウェブスクレイパー",
    'admin.missing_formulas': '数式が不足しています',
    'admin.broadcast_message': '放送メッセージ',
    'admin.receipt_verification': 'レシート確認',
    'admin.api_logs': 'システムAPIログ',
    'admin.recommendation_logs': 'レコメンドログ',
    'admin.search_logs': '検索ログ',
    'admin.banners': 'バナー管理',
    'admin.campaign': 'キャンペーン管理',
    'admin.rewards': '交換可能アイテム',
    'rewards.out_of_stock': '在庫切れ',

    // Admin Receipt Verification
    'admin.receipts.title': 'レシートの確認',
    'admin.receipts.user': 'ユーザー',
    'admin.receipts.promotion': 'プロモーション',
    'admin.receipts.date': '日付',
    'admin.receipts.amount': '金額',
    'admin.receipts.status_verified': '確認済み',
    'admin.receipts.status_rejected': '拒否',
    'admin.receipts.status_na': '該当なし',
    'admin.receipts.status_pending': '保留中',
    'admin.receipts.btn_verify': '確認する',
    'admin.receipts.btn_reject': '拒否する',
    'admin.receipts.btn_na': '該当なし',
    'admin.receipts.no_data': '保留中のレシートはありません。',

    'ai.title': 'AI スマートレコメンデーション',
    'ai.desc': '支出予定額を教えてください。当社のAIが、どのカードが今最もお得か計算します。',
    'ai.categories': 'カテゴリー',
    'ai.select_categories': 'カテゴリーを選択',
    'ai.target_spending': '目標支出額 ($) *',
    'ai.using_cards': '使用するカード:',
    'ai.using_payment_methods': '使用支払方法:',
    'ai.none_found': '見つかりません。プロフィールで追加してください。',
    'ai.thinking': '考え中...',
    'ai.get_recommendation': 'おすすめを取得',
    'ai.top_pick': 'おすすめ:',
    'ai.estimated_reward': '推定報酬:',
    'ai.no_suitable': 'この支出シナリオに適したプロモーションは見つかりませんでした。',
    'ai.more': 'その他',
    'ai.store_name': '店舗名',
    'ai.store_placeholder': '例: スターバックス',
    'ai.error_mandatory': 'カテゴリーを選択するか、店舗名を入力してください。',
    'ai.view_reasoning': '🤔 AIの推論を見る',
    'ai.store_deal': '🎯 店舗限定オファー',
    'ai.category_deal': '📂 カテゴリオファー',
    'ai.error_target_spending': '目標支出額は必須です。有効な金額を入力してください。',
    'ai.error_no_methods': '少なくとも1つのクレジットカードまたは支払方法を選択してください。',
    'ai.error_failed': 'おすすめの取得に失敗しました',

    'bill.title': '最適な支払いオファーを見つける',
    'bill.subtitle': '請求書（PDF）をアップロードすると、最適なクレジットカードやキャンペーンを見つけます。',
    'bill.upload_prompt': 'クリックして選択するか、請求書をドラッグ＆ドロップしてください（PDFのみ）',
    'bill.analyzing': '請求書を分析しています... お待ちください。',
    'bill.details': '抽出された請求書の詳細',
    'bill.company': '会社名',
    'bill.amount': '金額',
    'bill.due_date': '支払期日',
    'bill.finding_offers': '最適なオファーを探しています...',
    'bill.best_offers': 'この請求書におすすめのオファー',
    'bill.no_offers': 'この金額に対する特定の支払いオファーは見つかりませんでした。',

    'cc_modal.title': 'クレジットカードを選択',
    'cc_modal.filter_bank': '銀行で絞り込む',
    'cc_modal.filter_issuer': '発行会社で絞り込む',
    'cc_modal.all_banks': 'すべての銀行',
    'cc_modal.all_issuers': 'すべての発行会社',
    'cc_modal.search_placeholder': 'カードを検索...',
    'cc_modal.no_cards': '条件に一致するカードが見つかりませんでした。',
    'cc_modal.add_custom': 'カスタムカードを追加：',
    'cc_modal.custom_placeholder': '例：地元の銀行カード',
    'cc_modal.selected_count': '選択中',
    'cc_modal.confirm_btn': '選択を確定',
    'cc_modal.add_btn': '追加',

     // Intro Carousel
    'carousel.s1_title': 'もうお得な情報を見逃さない',
    'carousel.s1_desc': '無駄遣いをストップ。最適なクレジットカードと店舗のプロモーションを瞬時に検索。',
    'carousel.s2_title': '節約を最大化',
    'carousel.s2_desc': '支出の達成状況を追跡し、賢く買い物をするだけで追加の特典を獲得できます。',
    'carousel.s3_title': 'ビジネスを成長させる',
    'carousel.s3_desc': 'AIを活用したターゲットプロモーションで、適切なタイミングで適切な顧客にアプローチ。',
    'carousel.btn_member': '会員になる',
    'carousel.btn_claim': 'ビジネスを登録',

    'cat_modal.title': 'カテゴリーを選択',
    'cat_modal.search_placeholder': 'カテゴリーを検索...',
    'cat_modal.loading': '読み込み中...',
    'cat_modal.error_loading': 'カテゴリーの読み込みに失敗しました。',
    'cat_modal.no_results': '一致するカテゴリーが見つかりませんでした。',
    'cat_modal.confirm_btn': '選択を確定',

    // Store Modal
    'store_modal.title': '店舗を選択',
    'store_modal.search_placeholder': 'キーワードで店舗を検索...',
    'store_modal.add_btn': '追加',
    'store_modal.filter_by_category': 'カテゴリーで絞り込み：',
    'store_modal.all_categories': 'すべて',
    'store_modal.clear_categories': 'クリア',
    'store_modal.selected_count': '選択中',
    'store_modal.loading': '店舗を読み込み中...',
    'store_modal.error_loading': '店舗の読み込みに失敗しました。',
    'store_modal.no_stores_found': '条件に一致する店舗が見つかりませんでした。',
    'store_modal.no_results_add_prompt': '既存の店舗が見つかりません。「追加」をクリックして「{name}」を使用できます。',
    'store_modal.cancel_btn': 'キャンセル',
    'store_modal.confirm_btn': '選択を確定',

    'donate.error_stripe_key_missing': '設定にStripeキーがありません。',
    'donate.error_min_donation': '{currency} の最小寄付額は {minAmount} です',
    'donate.error_server_confirmation': '支払いは成功しましたが、サーバーの確認に失敗しました: {error}',
    'donate.title': 'SNAP PERKをサポート',
    'donate.subtitle': '皆様の寄付はプラットフォームの維持に役立てられます。',
    'donate.amount_label': '金額 ({currency})',
    'donate.min_hint': '最小: {minAmount}',
    'donate.name_label': '名前（任意）',
    'donate.name_placeholder': 'あなたの名前',
    'donate.email_label': 'メールアドレス（領収書用）',
    'donate.email_placeholder': 'you@example.com',
    'donate.message_label': 'メッセージ（任意）',
    'donate.hide_name': '公開リストに名前を非表示にする',
    'donate.processing': '処理中...',
    'donate.donate_btn': '{currency} {amount} を寄付する',
    'donate.confirming': '確認中...',
    'donate.confirm_payment': '支払いを確​​認',

    'donation_list.title': 'サポーターの皆様',
    'donation_list.subtitle': 'SNAP PERKを支援してくださった皆様に感謝いたします。',
    'donation_list.loading': '寄付リストを読み込み中...',
    'donation_list.error': '寄付リストの読み込みに失敗しました。',
    'donation_list.no_donations': 'まだ寄付はありません。最初のサポーターになりましょう！',
    'donation_list.anonymous': '匿名',
    'donation_list.column_date': '日付',
    'donation_list.column_name': '名前',
    'donation_list.column_amount': '金額',
    'donation_list.column_message': 'メッセージ',
    'donation_list.back_btn': '寄付する',

    // Home
    'home.active_promotions': '開催中のプロモーション',
    'home.sort_by': '並び替え',
    'home.sort.newest': '最新',
    'home.sort.ending_soon': '間もなく終了',
    'home.sort.name': '名前 (A-Z)',
    'home.sort.reward': '還元率 (高→低)',
    'home.sort.spend': '最低利用額 (低→高)',
    'home.loading': '読み込み中...',
    'home.no_data': '現在、有効なプロモーションはありません。',
    'home.load_more': 'さらに読み込む',

    // to do
    // Card
    'card.business_post': '公式',
    'card.selected_member': '限定会員',
    'card.starts': '開始',
    'card.ends': '終了',
    'card.min_spend': '最低利用額',
    'card.target_spend': '目標利用額',
    'card.up_to': '最大',
    'card.reward': '還元',
    'card.online': 'オンライン',
    'card.in_store': '店舗',
    'card.last_modified': '最終更新：',
    'card.edit': '編集',
    'card.favourite': 'お気に入り',
    'card.join': '参加する',
    'card.reg_req': '登録必須',
    'card.log': '記録',

    // to do
    'cardholders.back_to_promo': '← Back to Promotion',
    'cardholders.title_with_card': 'Users with {card}',
    'cardholders.subtitle': 'Connect with these users to enjoy exclusive card promotions.',
    'cardholders.loading': 'Loading users...',
    'cardholders.no_data': 'No users have listed this card yet.',
    'cardholders.anonymous': 'Anonymous User',
    'cardholders.view_profile': 'View Profile',

    // Log Transaction Modal
    'log_modal.title': '取引を記録',
    'log_modal.promo': 'プロモーション',
    'log_modal.amount': '消費額 ($)',
    'log_modal.date': 'レシート日付',
    'log_modal.receipt': 'レシートをアップロード (任意)',
    'log_modal.submit': '送信',
    'log_modal.cancel': 'キャンセル',
    'log_modal.error_amount': '有効な金額を入力してください。',
    'log_modal.error_failed': '取引の記録に失敗しました。',
    'log_modal.uploading': '処理中...',
    'log_modal.choose_file': 'ファイルを選択',

    'payment_modal.title': '支払方法を選択',
    'payment_modal.search_placeholder': 'リストを検索...',
    'payment_modal.loading': '読み込み中...',
    'payment_modal.error_loading': '支払方法を読み込めませんでした。',
    'payment_modal.no_data': '一致する支払方法が見つかりません。下からカスタム追加してください。',
    'payment_modal.add_custom_label': 'カスタム支払方法を追加：',
    'payment_modal.add_custom_placeholder': '例：現金',
    'payment_modal.add_btn': '追加',
    'payment_modal.selected_count': '選択中',
    'payment_modal.cancel_btn': 'キャンセル',
    'payment_modal.confirm_btn': '選択を確認',

    'promo_detail.title': 'プロモーション詳細',
    'promo_detail.official_link': '公式オファーを見る',
    'promo_detail.validity': '有効期間と日付',
    'promo_detail.eligibility': '利用条件',
    'promo_detail.banking': '銀行とカード',
    'promo_detail.locations': '利用可能な場所',
    'promo_detail.rewards': '特典詳細',
    'promo_detail.targets': 'チャレンジ目標',
    'promo_detail.eligible_days': '対象曜日',
    'promo_detail.specific_dates': '特定の日付',
    'promo_detail.online_shops': 'オンラインショップ',
    'promo_detail.physical_stores': '実店舗',
    'promo_detail.places': 'エリア / モール',
    'promo_detail.reward_tiers': '階層別特典',
    'promo_detail.condition': '条件',
    'promo_detail.reward_val': '特典',
    'promo_detail.max_reward': '最大特典上限',
    'promo_detail.reg_detail': '登録方法',
    'promo_detail.days.0': '日曜日',
    'promo_detail.days.1': '月曜日',
    'promo_detail.days.2': '火曜日',
    'promo_detail.days.3': '水曜日',
    'promo_detail.days.4': '木曜日',
    'promo_detail.days.5': '金曜日',
    'promo_detail.days.6': '土曜日',
    'promo_detail.who_has_this_card': 'このカードを持っているのは誰ですか？',

    'promotions.today_special_title': "本日の特別オファー",
    'promotions.no_specials': "今日の特別なオファーはありません。通常のプロモーションをチェックしてください！",
    'promotions.browse_all_promotions': "すべてのプロモーションを見る",
    'promotions.days_label': "該当日",
    'promotions.dates_label': "特定の日付",

    'public_profile.back_to_cardholders': '← Back to Card Holders ({card})',
    'public_profile.loading': 'Loading profile...',
    'public_profile.anonymous': 'Anonymous User',
    'public_profile.owned_cards': 'Owned Credit Cards',
    'public_profile.no_cards': 'This user has not listed any credit cards yet.',
    'public_profile.connect': 'Connect',
    'public_profile.email_address': 'Email Address',
    'public_profile.previously_unlocked': '✓ Previously Unlocked',
    'public_profile.hidden_10_credits': 'Hidden (Requires 10 Credits)',
    'public_profile.not_provided': 'Not provided by user',
    'public_profile.pay_10_reveal': 'Pay 10 Credits to Reveal',
    'public_profile.phone_im': 'Phone & Instant Messaging',
    'public_profile.hidden_20_credits': 'Hidden (Requires 20 Credits)',
    'public_profile.pay_20_reveal': 'Pay 20 Credits to Reveal',
    'public_profile.login_required': 'Please login to connect with users.',
    'public_profile.confirm_deduct': 'This will deduct {cost} credits from your balance. Proceed?',
    'public_profile.cannot_unlock_self': 'Cannot unlock own profile', // to do

    'mealdeals.breakfast': '朝食',
    'mealdeals.lunch': 'ランチ',
    'mealdeals.afternoon_tea': 'アフタヌーンティー',
    'mealdeals.dinner': 'ディナー',
    'mealdeals.midnight_snack': '夜食',
    'mealdeals.title': '{meal}の時間です！',
    'mealdeals.view_all': 'すべての{meal}のオファーを見る &rarr;',
    'mealdeals.up_to_percent': '最大 {reward}％ オフ',
    'mealdeals.save_up_to': '最大 ${reward} お得',
    'mealdeals.no_deals': '現在、特定の{meal}のオファーはありませんが、他のオファーをチェックしてください！',

    'partner.tagline': 'Snapperkメンバー限定のパートナーオファー',
    'partner.loading_collections': '最新コレクションを読み込んでいます...',
    'partner.no_offers': '現在、{brand}のオファーはありません。',
    'partner.fetch_error': 'パートナープロモーションの読み込みに失敗しました。',
    'partner.loading_details': '詳細を読み込んでいます...',
    'partner.not_found': 'プロモーションが見つかりません。',
    'partner.use_code': 'プロモコード：',
    'partner.shop_button': '公式ストアで購入する',

    // --- NEW: Scan Page ---
    'scan.title': 'プロモーション追加',
    'scan.subtitle': '入力方法を選択してください：',
    'scan.option1': '画像スキャン',
    'scan.option1_desc': 'クーポンのスクリーンショットや写真をアップロード。',
    'scan.scanning': 'スキャン中...',
    'scan.upload_btn': '画像アップロード',
    'scan.option2': 'URLスキャン',
    'scan.option2_desc': 'プロモーションページのリンクを貼り付け。',
    'scan.extract_btn': 'URLから抽出',
    'scan.manual_btn': '手動入力',
    'scan.or': 'または',

    'search.title': 'プロモーション検索',
    'search.keyword': 'キーワード (名前/詳細)',
    'search.bank': '銀行',
    'search.spending': '利用金額 ($)',
    'search.options': 'オプション',
    'search.online': 'オンライン',
    'search.instore': '店舗',
    'search.hide_filters': 'フィルターを隠す',
    'search.show_filters': 'フィルターを表示',
    'search.expired': '期限切れを含む',
    'search.upcoming': '開催予定を含む',
    'search.categories': 'カテゴリ',
    'search.select_categories': 'カテゴリ選択',
    'search.methods': '支払方法',
    'search.select_methods': '支払方法選択',
    'search.stores': '店舗',
    'search.select_stores': '店舗選択',
    'search.credit_cards': 'クレジットカード',
    'search.select_cards': 'カード選択',
    'search.places': '場所',
    'search.select_places': '場所を選択',
    'search.selected': '選択中',
    'search.reset': 'リセット',
    'search.btn': '検索',
    'search.searching': '検索中...',
    'search.enter_criteria': '検索条件を入力してください。',
    'search.no_results': '次の地域で条件に一致するプロモーションが見つかりませんでした：',
    'search.load_more': 'さらに読み込む',
    'geo.location_aware': '位置認識',
    'geo.beta': 'ベータ版',
    'geo.locating': '位置情報を取得中...',
    'geo.location_ready': '位置情報が有効です',
    'geo.permission_denied': '位置情報の権限が拒否されたか、利用できません',
    'geo.not_supported': 'お使いのブラウザは位置情報をサポートしていません',
    'geo.nearby': '周辺',
    'geo.away': '離れた場所',

    // --- NEW: Home Tabs ---
    'tabs.promotions': '開催中のプロモーション',
    'tabs.products': '商品割引',

    'top_savers.title': 'トップセーバー',
    'top_savers.subtitle': '最もアクティブな節約家',
    'top_savers.rank': 'ランク',
    'top_savers.user': 'ユーザー',
    'top_savers.savings': '総節約額',
    'top_savers.view_transactions': '取引を見る',
    'top_savers.period.day': '今日',
    'top_savers.period.week': '今週',
    'top_savers.period.month': '今月',
    'top_savers.period.year': '今年',
    'top_savers.period.all_time': '全期間',
    'top_savers.no_data': 'データが見つかりませんでした',

    // User Transactions Modal 
    'transactions_modal.title': '最近の取引',
    'transactions_modal.date': '日付',
    'transactions_modal.promotion': 'プロモーション',
    'transactions_modal.amount': '消費額',
    'transactions_modal.reward': '賞',
    'transactions_modal.no_data': '取引が見つかりません。',
    'transactions_modal.close': '閉じる',
    'transactions_modal.receipt': 'レシート',
    'transactions_modal.status_verified': '確認済み',
    'transactions_modal.status_rejected': '拒否',
    'transactions_modal.status_na': '該当なし',
    'transactions_modal.status_pending': 'レシートアップロード済み（審査待ち）',

    'banners.loading': '注目のオファーを読み込んでいます...',
    'admin.banners.title': 'バナー管理',
    'admin.banners.add': '新しいバナーを追加',
    'admin.banners.edit': 'バナーを編集',

    'admin.store.title': '店舗名管理',
    'admin.store.edit': '店舗編集',
    'admin.store.add': '新規店舗追加',
    'admin.store.name': '店舗名',
    'admin.store.country': '国コード',
    'admin.store.save': '変更を保存',
    'admin.store.add_btn': '店舗追加',
    'admin.store.bulk': '一括アップロード',
    'admin.store.csv_hint': 'CSV形式：ヘッダー `name`、その後に1行に1つの店舗名。',
    'admin.store.upload': 'CSVアップロード',
    'admin.store.uploading': 'アップロード中...',
    'admin.store.existing': '既存の店舗',
    'admin.store.none': '店舗が見つかりません。',
    'admin.store.delete_confirm': 'この店舗を削除してもよろしいですか？',
    'admin.store.success_update': '店舗を更新しました。',
    'admin.store.success_add': '店舗を追加しました。',
    'admin.store.success_delete': '店舗を削除しました。',
    'admin.store.success_upload': 'アップロード成功！新規 {inserted} 件、更新 {updated} 件。',
    'admin.store.locations': '店舗所在地',
    'admin.store.address': '住所',
    'admin.store.lat': '緯度',
    'admin.store.lng': '経度',
    'admin.store.add_loc_btn': '場所を追加',
    'admin.store.no_locs': '実店舗の場所がまだありません。',
    'admin.store.loc_list': '既存の場所',
    'admin.store.populate_title': 'Web/コンテンツから店舗を自動生成',
    'admin.store.input_mode_url': 'Web URL',
    'admin.store.input_mode_content': 'ページ内容 / HTMLを直接貼り付け',
    'admin.store.english_url': '英語ブランドURL',
    'admin.store.non_english_url': '非英語ブランドURL (中国語など)',
    'admin.store.english_content': '英語ページ内容 / HTMLコード',
    'admin.store.non_english_content': '非英語 (日本語/中国語等) ページ内容 / HTMLコード (任意)',
    'admin.store.content_hint': 'ヒント：Cloudflare 403ブロックが発生する場合(例: 香港空港など)、ブラウザでページを開き、全選択(Ctrl+A)してコピーし、ここに貼り付けてください。',
    'admin.store.predefined_alias': '定義済みのエイリアス',
    'admin.store.predefined_categories': '定義済みのカテゴリ',
    'admin.store.extract_save': '抽出して保存',
    'admin.store.extracting': '抽出中...',
    'admin.store.search_placeholder': '🔍 店舗名またはエイリアスで検索...',
    'admin.store.success_populate': '店舗の取り込みに成功しました！抽出：{extracted}、追加：{inserted}、スキップ：{skipped}',
    'admin.store.places': '所属ショッピングモール / エリア',
    'admin.store.no_places': '登録済みエリアがありません。エリア管理で追加してください。',
    'admin.store.tab_directory': '店舗ディレクトリ＆編集',
    'admin.store.tab_csdi_matched': 'CSDI位置情報インポーター (マッチ済み)',
    'admin.store.tab_csdi_unmatched': '未マッチCSDI地点',
    'admin.store.tab_track_records': '操作ログ',
    'admin.store.aliases': '店舗エイリアス (カンマ区切り)',
    'admin.store.aliases_placeholder': '例: Wellcome, 惠康スーパー',
    'admin.store.enable_profile': '店舗プロファイル＆ブランドページを有効化',
    'admin.store.profile_hint': 'ユーザーがこの店舗の専用ブランドページや所在地一覧を閲覧できるようにします。',
    'admin.store.activation_code': 'アクティベーションコード (店舗管理者連携)',
    'admin.store.generate_code': 'コード生成',
    'admin.store.activation_code_hint': '実店舗の加盟店にこのコードを共有してビジネスアカウントを連携します。',
    'admin.store.lookup_gps': 'GPS検索',
    'admin.store.searching_gps': '検索中...',
    'admin.store.places_label': 'モール/エリア',
    'admin.store.locations_label': '店舗所在地',
    'admin.store.remove': '削除',
    'admin.store.showing_range': '{total} 件中 {start} - {end} 件目を表示',
    'admin.store.track_title': '変更履歴と監査ログ',
    'admin.store.track_hint': '店舗の追加、変更、インポート、削除の履歴。1クリックでエディタに復元できます。',
    'admin.store.track_filter': '店舗で絞り込み...',
    'admin.store.restore': 'エディタに復元',
    'admin.store.no_track_records': '履歴ログが見つかりません。',
    'admin.store.auto_heal_title': '座標自動修復 (BulkWrite)',
    'admin.store.auto_heal_desc': 'Places、CSDI レコード、および Stores 内の破損した HK80 座標をスキャンして一括修復します。',
    'admin.store.auto_heal_btn': '一括修復を実行',
    'admin.store.auto_heal_confirm': 'MongoDB の BulkWrite を使用して座標の一括修復を実行しますか？',
    'admin.store.auto_heal_running': 'BulkWrite で座標を一括修復中...',
    'admin.store.auto_heal_healthy': 'すべての座標は正常です。破損したレコードはありません。',
    'admin.store.auto_heal_corrupted_found': '破損した座標が {total} 件見つかりました ({places} 件の Places, {csdi} 件の CSDI, {stores} 件の Stores)。',
    'admin.store.auto_heal_success': 'BulkWrite により {total} 件の座標を正常に修復しました ({places} 件の Places, {csdi} 件の CSDI, {stores} 件の Stores)。',
    'admin.store.auto_heal_refresh': '再チェック',

    // CSDI Location Importer
    'admin.csdi.upload_title': 'CSDI / FEHD 一括CSVアップロード',
    'admin.csdi.upload_hint': '香港のPOI情報を含む大容量CSV（9.5MB以上、50,000行以上）をアップロードします。バックグラウンドで純粋な数学的座標変換を行い、リアルタイムで進捗を表示します。',
    'admin.csdi.choose_csv': 'CSVを選択してマッチング',
    'admin.csdi.processing_bg': 'バックグラウンドで処理中...',
    'admin.csdi.import_complete': 'インポート完了',
    'admin.csdi.processing_error': '処理エラー',
    'admin.csdi.uploading_csv': 'CSVファイルをアップロード中...',
    'admin.csdi.processing_records': 'バックグラウンドでCSDIレコードを処理中...',
    'admin.csdi.total_rows': '総行数',
    'admin.csdi.processed': '処理済み',
    'admin.csdi.matched_stores': 'マッチした店舗',
    'admin.csdi.high_confidence': '高信頼度',
    'admin.csdi.unmatched_pois': '未マッチPOI',
    'admin.csdi.pending_review': '確認待ち',
    'admin.csdi.high_confidence_safe': '高信頼度 (安全)',
    'admin.csdi.needs_review': '要確認',
    'admin.csdi.already_applied': '適用済み',
    'admin.csdi.discovered_malls_title': '未登録ショッピングモールの自動検出',
    'admin.csdi.discovered_malls_hint': 'CSDIデータから検出されたモール（何文田広場、徳福広場、富東広場など）で、エリアDBに未登録のものです。登録すると店舗所在地が自動的に「高信頼度」で紐付けられます。',
    'admin.csdi.rescan_malls': 'モール再スキャン',
    'admin.csdi.add_selected_malls': '選択したモールを登録して再マッチング',
    'admin.csdi.adding_malls': '登録＆再マッチング中...',
    'admin.csdi.mall_name_en_zh': 'モール名 (英語＆中国語)',
    'admin.csdi.short_tag': 'ショートタグ',
    'admin.csdi.district_address': '地区＆住所',
    'admin.csdi.centroid_gps': '中心GPS座標',
    'admin.csdi.detected_stores': '検出店舗数',
    'admin.csdi.action': 'アクション',
    'admin.csdi.add_and_link': '追加＆紐付け',
    'admin.csdi.no_gps': 'GPSなし',
    'admin.csdi.scanning': 'スキャン中...',
    'admin.csdi.scan_prompt': 'CSDIに未登録のモールがありますか？スキャンして検出されたモール（何文田広場、徳福広場など）をエリアDBに追加します。',
    'admin.csdi.scan_btn': '未登録モールをスキャン',
    'admin.csdi.all_stores': 'すべての店舗',
    'admin.csdi.status_pending': '確認待ち',
    'admin.csdi.status_applied': '適用済み',
    'admin.csdi.status_rejected': '却下済み',
    'admin.csdi.all_statuses': 'すべてのステータス',
    'admin.csdi.all_confidences': 'すべての信頼度',
    'admin.csdi.high_confidence_only': '高信頼度のみ',
    'admin.csdi.medium_confidence': '中信頼度',
    'admin.csdi.low_confidence': '低信頼度',
    'admin.csdi.search_address_store': '住所 / 店舗名で検索...',
    'admin.csdi.quick_apply': '高信頼度レコードを一括適用',
    'admin.csdi.apply_selected': '選択項目を適用',
    'admin.csdi.reject_selected': '選択項目を却下',
    'admin.csdi.th_store': '店舗名 (CSDI名称)',
    'admin.csdi.th_address': '検出住所＆地区',
    'admin.csdi.th_gps': '所在地GPS',
    'admin.csdi.th_action_override': '提案アクション＆モール変更',
    'admin.csdi.th_confidence_reason': '信頼度と判定理由',
    'admin.csdi.th_actions': '操作',
    'admin.csdi.opt_street': '路面店',
    'admin.csdi.opt_mall': 'モール内店舗:',
    'admin.csdi.btn_apply': '適用',
    'admin.csdi.btn_reject': '却下',
    'admin.csdi.no_staged_records': '条件に一致する保留レコードはありません。',
    'admin.csdi.unmatched_title': '未マッチのCSDI地点データ',
    'admin.csdi.unmatched_hint': '既存の店舗ブランドに自動マッチしなかったPOIです。内容を確認し、モールに紐付けて新規店舗として1クリックで登録できます。',
    'admin.csdi.unmatched_search_placeholder': '未マッチPOI / 住所 / 地区で検索...',
    'admin.csdi.btn_create_store': '新規店舗を作成',
    'admin.csdi.th_poi_name': '施設 / POI名',
    'admin.csdi.th_poi_address': '検出住所',
    'admin.csdi.th_poi_gps': 'GPS座標',
    'admin.csdi.th_nearest_mall': '最寄りの検出モール',
    'admin.csdi.modal_create_store_title': 'CSDIレコードから新規店舗を作成',
    'admin.csdi.modal_create_store_hint': '店舗ディレクトリに新規ブランドを登録し、初期所在地とGPSを設定してショッピングモールと紐付けます。',
    'admin.csdi.initial_address': '初期店舗住所',
    'admin.csdi.associated_mall': '関連ショッピングモール (エリア)',
    'admin.csdi.select_mall_opt': '関連モールを選択 (任意)',
    'admin.csdi.street_shop_none': '独立した路面店 (なし)',
    'admin.csdi.btn_create_link': '店舗を作成して場所を紐付け',
    'admin.csdi.creating': '作成中...',
    'admin.place.title': 'エリア / ショッピングモール管理',
    'admin.place.edit': 'エリアを編集',
    'admin.place.add': 'エリアを追加',
    'admin.place.name': 'エリア / モール名 (主要 / 表示名)',
    'admin.place.name_en': '英語名 (例: Times Square)',
    'admin.place.name_zh': '繁体字中国語名 (例: 時代廣場)',
    'admin.place.name_ja': '日本語名 (例: タイムズスクエア)',
    'admin.place.short_tag': 'ショートタグ / ハッシュタグ (例: TimesSquare)',
    'admin.place.country': '国コード',
    'admin.place.address': '住所',
    'admin.place.lookup_btn': '座標を検索',
    'admin.place.csdi_btn': 'CSDI検索',
    'admin.place.csdi_searching': 'CSDI検索中...',
    'admin.place.csdi_found': 'CSDIから自動入力しました: {name}',
    'admin.place.csdi_none': 'CSDIで一致する地点が見つかりませんでした。',
    'admin.place.lat': '緯度',
    'admin.place.lng': '経度',
    'admin.place.coordinates': 'GPS座標',
    'admin.place.no_coords': 'GPS座標未設定',
    'admin.place.save': '保存',
    'admin.place.add_btn': '追加',
    'admin.place.cancel': 'キャンセル',
    'admin.place.existing': '登録済みエリア / モール',
    'admin.place.none': 'エリアが見つかりません。',
    'admin.place.delete_confirm': 'このエリアを削除してもよろしいですか？',
    'admin.place.success_add': 'エリアを追加しました。',
    'admin.place.success_update': 'エリアを更新しました。',
    'admin.place.success_delete': 'エリアを削除しました。',
    'admin.place.bulk_upload': 'CSV一括アップロード',
    'admin.place.bulk_upload_hint': '対応する列: name, nameZh, countryCode, shortTag, address, lat, lng (または公式CSDI CSV: NAME_EN, NAME_ZH, EASTING, NORTHING)。',
    'admin.place.download_template': 'CSVテンプレートをダウンロード',
    'admin.place.upload_btn': '地点CSVをアップロード',
    'admin.place.uploading': 'アップロード中...',
    'admin.place.upload_success': '一括アップロードに成功しました！処理数: {processed}、追加: {inserted}、更新: {modified}。',
    'admin.place.search_placeholder': '🔍 エリア名、タグ、住所で検索...',
    'admin.place.showing_range': '{total} 件中 {start} - {end} 件目を表示',
    'card.code': 'コード',
    'card.max_target_transactions': '最大目標取引数',
    'card.max_target_spend': '最大目標支出額',
    'card.your_reward': 'あなたの報酬',


    'admin.ai_models': 'AIモデル管理',
    'admin.ai_models.title': 'AIモデル管理',
    'admin.ai_models.discover_btn': 'Geminiモデルの自動検出',
    'admin.ai_models.discover_deepseek_btn': 'DeepSeekモデルの自動検出',
    'admin.ai_models.discovering': '検出中...',
    'admin.ai_models.discovering_deepseek': 'DeepSeek検出中...',
    'admin.ai_models.models_title': '利用可能なAIモデル',
    'admin.ai_models.failed_title': '最近の失敗モデル記録',
    'admin.ai_models.table_name': 'モデルID / 名前',
    'admin.ai_models.table_provider': 'プロバイダー',
    'admin.ai_models.table_display': '表示名',
    'admin.ai_models.table_status': 'ステータス',
    'admin.ai_models.table_actions': '操作',
    'admin.ai_models.table_failed_at': '失敗日時',
    'admin.ai_models.table_reason': '失敗理由',
    'admin.ai_models.table_priority': '優先度',
    'admin.ai_models.status_enabled': '有効',
    'admin.ai_models.status_disabled': '無効',
    'admin.ai_models.btn_enable': '有効化',
    'admin.ai_models.btn_disable': '無効化',
    'admin.ai_models.btn_clear_fail': '失敗クリア',
    'admin.ai_models.no_failed_models': '失敗したモデルはありません。',
    'admin.ai_tasks': 'AI タスク設定',
    'admin.ai_tasks.title': 'AI タスク設定',
    'admin.ai_tasks.subtitle': 'ワークロードごとにAIモデルの優先パイプラインとタイムアウトを管理します。選択可能なモデルは、AIモデル管理で有効化されているモデルから動的に取得されます。',
    'admin.ai_tasks.tab_models': 'AIモデル管理',
    'admin.ai_tasks.tab_tasks': 'タスク設定',
    'admin.ai_tasks.select_task': 'AIタスクを選択',
    'admin.ai_tasks.task_name': 'タスク名',
    'admin.ai_tasks.task_desc': '説明',
    'admin.ai_tasks.timeout': 'タイムアウト（秒）',
    'admin.ai_tasks.model_pipeline': 'モデル優先パイプライン',
    'admin.ai_tasks.pipeline_hint': 'リクエストは上から順にモデルを試行します。モデルが失敗またはタイムアウトした場合、自動的に次のモデルが呼び出されます。',
    'admin.ai_tasks.add_model': 'パイプラインにモデルを追加',
    'admin.ai_tasks.select_model': '-- 有効なモデルを選択 --',
    'admin.ai_tasks.no_enabled_models': '追加可能な有効モデルがありません。',
    'admin.ai_tasks.move_up': '上へ',
    'admin.ai_tasks.move_down': '下へ',
    'admin.ai_tasks.remove': '削除',
    'admin.ai_tasks.save': '設定を保存',
    'admin.ai_tasks.saving': '保存中...',
    'admin.ai_tasks.save_success': 'タスク設定が正常に更新されました。',
    'admin.ai_tasks.save_error': 'タスク設定の保存に失敗しました。',
    'admin.ai_tasks.task_recommendation': 'プロモーション推奨',
    'admin.ai_tasks.task_image_scanning': '画像スキャンとOCR',
    'admin.ai_tasks.empty_pipeline': 'パイプラインにモデルがありません。少なくとも1つの有効なモデルを追加してください。',
    'admin.ai_tasks.fast_multimodal_hint': '高速なOCR認識を実現するため、超高速マルチモーダルモデル（gemini-2.5-flashなど）をパイプラインの最上位に配置することをお勧めします。',
    'admin.ai_tasks.seed_fast_models': '推奨高速モデルにリセット',
    'admin.ai_tasks.seed_fast_models_confirm': '画像スキャンパイプラインを推奨の高速マルチモーダルモデルにリセットしますか？',

    // Admin System Settings
    'admin.cron_jobs': 'クロンジョブと定期プロモーション',
    'admin.system_settings': 'システム設定',
    'admin.system_settings.title': 'コンテンツモデレーションとスパム対策設定',
    'admin.system_settings.subtitle': '画像品質チェック、スパム検出、および再犯停止のしきい値を設定します。',
    'admin.system_settings.blur_threshold': '画像のぼやけ鮮明度しきい値（ラプラシアン分散）',
    'admin.system_settings.blur_hint': 'このしきい値未満の画像は不鮮明と判定されます（デフォルト：90.0）。',
    'admin.system_settings.blank_threshold': '空白画像の輝度分散しきい値',
    'admin.system_settings.blank_hint': '輝度の標準偏差がこのしきい値未満の画像は空白または単色と判定されます（デフォルト：8.0）。',
    'admin.system_settings.spam_ban_threshold': '24時間停止となる違反カウント上限',
    'admin.system_settings.spam_hint': '拒否されたプロモーション数がこの上限に達すると、自動的に24時間の投稿停止が適用されます（デフォルト：3）。',
    'admin.system_settings.ban_duration': '停止期間（時間）',
    'admin.system_settings.ban_duration_hint': '違反カウント上限到達時の投稿停止時間（デフォルト：24）。',
    'admin.system_settings.radius_title': 'リアルタイム位置・周辺検索半径 (km)',
    'admin.system_settings.radius_hint': '「近く」タブのプロモーション、リアルタイム位置情報検索、周辺モールハッシュタグのデフォルト検索範囲（デフォルト：2.0 km）。',
    'admin.system_settings.geofence_limit': 'ジオフェンス検証距離上限（メートル）',
    'admin.system_settings.geofence_hint': '実店舗プロモーション投稿の検証時に、ユーザーGPSと店舗GPS間で許可される最大距離（デフォルト：200m）。',
    'admin.system_settings.duplicate_hamming_threshold': '重複画像のハミング距離しきい値',
    'admin.system_settings.duplicate_hamming_hint': '2つの画像を類似重複とみなす最大知覚ハッシュのハミング距離（0〜16）。低い値にすると誤検知が減ります（デフォルト：3）。',
    'admin.system_settings.trusted_template_providers': '信頼済みテンプレートプロバイダー（カンマ区切り）',
    'admin.system_settings.trusted_template_providers_hint': 'UIスクリーンショットが標準化された決済・ウォレットアプリ（例：PayMe、AlipayHK、WeChat Pay）。タイトルまたは期間が異なる場合、類似画像の重複判定から除外されます。',
    'admin.system_settings.save': '設定を保存',
    'admin.system_settings.saving': '保存中...',
    'admin.system_settings.save_success': 'システム設定が正常に保存されました。',
    'admin.system_settings.save_error': 'システム設定の保存に失敗しました。',

    // Admin Users Ban Management
    'admin.users.ban_status': '投稿停止ステータス',
    'admin.users.banned_until': '停止期限',
    'admin.users.unban': '停止解除',
    'admin.users.unban_confirm': 'このユーザーのプロモーション投稿停止を解除してもよろしいですか？',
    'admin.users.unbanned_success': 'ユーザーの投稿停止が解除されました。',
    'admin.users.clean_status': '正常',
    'admin.users.strikes': '違反カウント',
    'admin.users.ban_history': '停止履歴',
    'admin.users.no_ban_history': '停止履歴はありません。',

    // Promotion Lifecycle: Ban & Delete
    'promo.ban_btn': 'プロモーションを停止',
    'promo.ban_confirm': 'このプロモーションを停止してもよろしいですか？公開検索から非表示になります。',
    'promo.ban_reason_prompt': '停止理由を入力（任意）：',
    'promo.banned_success': 'プロモーションが停止されました。',
    'promo.delete_btn': 'プロモーションを削除',
    'promo.delete_confirm': 'このプロモーションを削除してもよろしいですか？この操作は取り消せません。',
    'promo.delete_success': 'プロモーションが正常に削除されました。',
    'promo.error.cannot_delete_has_challenges': 'ユーザーが関連するチャレンジまたは実績に参加しているため、プロモーションを削除できません。',
    'promo.error.banned': 'スパムまたは低品質な投稿が複数回確認されたため、アカウントは {date} までプロモーションの投稿が停止されています。',
    'promo.error.dummy_text': '有効なプロモーションのタイトルと説明を入力してください。',
    'promo.error.blank_image': '選択された画像は空白または単色のようです。鮮明な写真をアップロードしてください。',
    'promo.error.blurry_image': '画像が不鮮明で読み取れません。より鮮明な写真をアップロードしてください。',
    'promo.error.sensitive_info': '機密情報（クレジットカード番号や身分証明書など）を含むプロモーションは提出できません。',

    'common.prev': '前へ',
    'common.next': '次へ',
    'common.page': 'ページ',
    'common.of': '/',
    'common.page_of': '{page} / {total} ページ',
    'common.cancel': 'キャンセル',
    'common.edit': '編集',
    'common.delete': '削除',
    'common.loading': '読み込み中...',

    // Admin Banned Promotions
    'admin.banned_promotions': '利用停止プロモーション',
    'admin.banned_promos.title': '利用停止プロモーション',
    'admin.banned_promos.subtitle': '利用停止または却下されたプロモーションを確認・管理します。',
    'admin.banned_promos.promo_name': 'プロモーション名',
    'admin.banned_promos.author': '投稿者',
    'admin.banned_promos.created_at': '作成日時',
    'admin.banned_promos.verification_status': '検証ステータス',
    'admin.banned_promos.rejection_reason': '却下理由',
    'admin.banned_promos.actions': 'アクション',
    'admin.banned_promos.unban_btn': '停止解除',
    'admin.banned_promos.unbanning': '解除中...',
    'admin.banned_promos.unban_confirm': 'このプロモーションの停止を解除してもよろしいですか？有効かつ検証済みに戻ります。',
    'admin.banned_promos.unban_success': 'プロモーションの停止を解除しました。',
    'admin.banned_promos.unban_failed': 'プロモーションの停止解除に失敗しました。',
    'admin.banned_promos.no_data': '停止中のプロモーションはありません。',
    'admin.banned_promos.unknown_author': '不明',

    // Tax Calculator
    'tax.fab_title': '税金還元',
    'tax.fab_subtitle': '納税計算機',
    'tax.fab_dismiss': '閉じる',
    'tax.banner_title': '納税リベート計算機',
    'tax.banner_subtitle': '香港のクレジットカードや決済プラットフォームでお得な納税リベートを最大化',
    'tax.section1_title': '1. リベート設定',
    'tax.pref_cash': 'キャッシュバック ($)',
    'tax.pref_cash_desc': '請求相殺または現金クーポン',
    'tax.pref_miles': 'マイル (Miles)',
    'tax.pref_miles_desc': 'アジア・マイルおよびマイレージポイント',
    'tax.section2_title': '2. 納税総額',
    'tax.section3_title': '3. 分割払い (任意)',
    'tax.pay_installments': '分割払いで納税',
    'tax.installment_schedule_subtitle': '分割払いスケジュール：',
    'tax.split_2': '2回分割',
    'tax.split_3': '3回分割',
    'tax.add_installment': '+ 追加',
    'tax.installment_sum_matched': '✓ 分割合計が納税総額と一致: HK$ {sum}',
    'tax.installment_diff': '⚠️ 差額: HK$ {diff} ({reason})',
    'tax.exceeds_tax': '納税総額を超過',
    'tax.remaining_unallocated': '未割当金額あり',
    'tax.section4_title': '4. 納税プロモーション',
    'tax.cross_promotion': 'プロモーション最適化',
    'tax.promos_selected': '{selected}/{total} 件選択中',
    'tax.select_all': 'すべて選択',
    'tax.clear': 'クリア',
    'tax.same_bank_warning': '同一銀行／プラットフォームにつき適用可能な納税プロモーションは1件のみの場合があります ({bank})。',
    'tax.promo_expires_warning': '{brand} のプロモーションは予定された分割支払日前に終了します。',
    'tax.loading_promos': '納税プロモーションを読み込み中...',
    'tax.empty_promos_msg': '納税プロモーションの準備中です。情報提供も歓迎します',
    'tax.add_promo_btn': '+ プロモーションを追加',
    'tax.air_miles_promo': 'マイルプロモーション',
    'tax.cash_rebate_promo': 'キャッシュバックプロモーション',
    'tax.calculate_btn': '納税リベートを計算',
    'tax.share_card.tagline': '納税リベート計算機',
    'tax.share_card.total_tax': '納税総額',
    'tax.share_card.optimized_rebate': '最適化リベート',
    'tax.share_card.best_rebate': '最大リベート',
    'tax.share_card.installment_schedule': '分割スケジュール',
    'tax.share_card.allocation_strategy': '配分戦略',
    'tax.share_card.installment_item': '第 {index} 期 (HK$ {amount})',
    'tax.share_card.due_date': '期日: {date}',
    'tax.share_card.watermark': 'SnapPerkで計算 | 香港のスマートプロモーションエンジン',
    'tax.share_card.copied': '✓ コピー完了',
    'tax.share_card.share': '📤 概要をシェア',
    'tax.share_card.summary_title': '🌟 SNAP PERK 納税リベート概要',
    'tax.share_card.calculated_on': '📅 計算日時: {date}',
    'tax.share_card.total_tax_line': '💰 納税総額: HK${tax}',
    'tax.share_card.max_rebate_line': '🎯 最大リベート: {rebate}',
    'tax.share_card.strategy_header': '📋 戦略:',
    'tax.share_card.installment_header': '📋 分割払いの内訳:',
    'tax.share_card.installment_row': '• 第 {index} 期: HK${amount}{due} => リベート: {rebate}',
    'tax.share_card.cta': '🚀 SNAP PERK でクレジットカード納税リベートを計算: https://www.snapperk.app/tax-calculator',
    'tax.tiered_rebate': '段階的リベート',
    'tax.min_spend': '最低利用額',
    'tax.fixed_rebate': '定額リベート',
    'tax.rebate': 'リベート',
    'tax.capped_at': '上限',
    'tax.tier_reached': '達成ティア',
    'tax.no_additional_rebate': '追加リベートなし (基準額未満)',
    'tax.below_min_spend': '最低利用額未満 ({amount})',
    'tax.hit_max_cap': '上限額に到達 {amount}',
    'tax.fixed_reward_reached': '定額特典達成 ({amount})',
    'tax.promo_expired_due_date': 'プロモーションは期日前に終了しました',
    'tax.miles_2k_reward': '2,000 マイル (HK$3,000の利用が必要)',
    'tax.miles_4k_reward': '4,000 マイル (HK$20,000の利用が必要)',
    'tax.below_min_miles_spend': '最低マイル獲得利用額未満 (HK$3,000)',
    'tax.miles_bea_desc': '2,000 マイル (HK$3,000 利用) または 4,000 マイル (HK$20,000 利用)',
    'tax.spend_x_for_y_rebate': '{spend} 利用で {rebate} 還元',

    // Open Account Calculator
    'open_account.fab_title': '口座開設',
    'open_account.fab_subtitle': 'リワード計算',
    'open_account.fab_dismiss': '閉じる',
    'open_account.banner_title': '口座開設リワード計算機',
    'open_account.banner_subtitle': '新規資金を複数の銀行口座開設キャンペーンに配分し、最大リワードを獲得',
    'open_account.section1_title': '1. リワード設定',
    'open_account.pref_cash': '現金還元 ($)',
    'open_account.pref_cash_desc': 'キャッシュバック・口座明細還元・ギフト券',
    'open_account.pref_miles': 'マイル (Miles)',
    'open_account.pref_miles_desc': 'アジア・マイル＆マイレージポイント',
    'open_account.section2_title': '2. 新規資金額',
    'open_account.new_money_label': '新規資金総額 (HK$)',
    'open_account.section3_title': '3. 口座開設キャンペーンを選択',
    'open_account.cross_promotion': '複数口座配分の最適化',
    'open_account.cross_promotion_desc': '複数の口座に資金を配分し、合算リワードを最大化',
    'open_account.promos_selected': '{selected}/{total} 件選択中',
    'open_account.select_all': 'すべて選択',
    'open_account.clear': 'クリア',
    'open_account.same_bank_warning': '同一銀行グループ（{bank}）では1つの口座のみ開設可能です。',
    'open_account.loading_promos': '口座開設キャンペーンを読み込み中...',
    'open_account.empty_promos_msg': '口座開設キャンペーンの追加に向けて準備を進めています',
    'open_account.add_promo_btn': '+ キャンペーンを追加',
    'open_account.calculate_btn': '最適な組み合わせを計算',
    'open_account.share_card.tagline': '口座開設リワード最適化',
    'open_account.share_card.total_money': '新規資金総額',
    'open_account.share_card.allocated': '配分預金総額',
    'open_account.share_card.unallocated': '未配分資金',
    'open_account.share_card.optimized_reward': '最適リワード',
    'open_account.share_card.best_reward': '最大リワード',
    'open_account.share_card.allocation_strategy': '最適配分戦略',
    'open_account.share_card.single_comparison': '単一口座比較',
    'open_account.share_card.single_comparison_desc': '全額を1つの口座に預けた場合',
    'open_account.share_card.gain_vs_single': '最良の単一口座より +{gain} (+{percent}%) お得',
    'open_account.share_card.deposit_req': '預入 HK${amount}',
    'open_account.share_card.watermark': "Calculated with SnapPerk | Hong Kong's Smartest Promotion Engine",
    'open_account.share_card.copied': '✓ コピー完了',
    'open_account.share_card.share': '📤 概要を共有',
    'open_account.share_card.summary_title': '🌟 SNAP PERK 口座開設リワード概要',
    'open_account.share_card.calculated_on': '📅 計算日: {date}',
    'open_account.share_card.total_line': '💰 新規資金総額: HK${money}',
    'open_account.share_card.allocated_line': '🏦 配分預金額: HK${amount}',
    'open_account.share_card.unallocated_line': '💵 未配分残額: HK${amount}',
    'open_account.share_card.max_reward_line': '🎯 最大リワード: {reward}',
    'open_account.share_card.strategy_header': '📋 最適配分戦略:',
    'open_account.share_card.account_row': '• {bank} ({name}): 預入 HK${amount} => リワード: {reward}',
    'open_account.share_card.cta': '🚀 SNAP PERKで口座開設リワードを最適化: https://www.snapperk.app/open-account-calculator',
    'open_account.deposit_x_for_y': '{deposit} 預入で {reward} リワード',

    // Handy Tools
    'tools.title': '便利ツール',
    'tools.subtitle': 'リワードや特典を最大化する専用計算ツール',
    'tools.coming_soon': '近日公開',
    'tools.open_tool': '計算機を開く',
    'tools.tax_title': '納税リベート計算機',
    'tools.tax_desc': '香港のクレジットカードや決済プラットフォームでお得な納税リベートを最大化',
    'tools.open_account_title': '口座開設リワード計算機',
    'tools.open_account_desc': '新規資金を複数の銀行口座開設キャンペーンに配分し、最大リワードを獲得',
    'tools.time_deposit_title': '定期預金オプティマイザー',
    'tools.time_deposit_desc': '定期預金の金利リターンを比較・最大化',
    'tools.spending_split_title': 'マイルストーン利用額計算機',
    'tools.spending_split_desc': '大きな買い物を複数カードに分散し、達成特典を最大化',
    'tools.air_miles_title': 'マイル現金価値換算',
    'tools.air_miles_desc': 'マイルとキャッシュバックの実質還元価値を換算',
    'tools.stay_tuned': 'この専用ツールは現在開発中です。公開をお楽しみに！'
  }
};